const messages = {
  en: {
    translations: {
      titles: {
        home: 'Home',
        resources: 'Resources',
        teaching: 'Teaching',
        support: 'Support',
        language: 'Language',
        contents: 'Contents',
        integration: 'Integration',
        contact: 'Contact',
        compliance: 'Compliance',
        signup: 'Sign Up',
        signupSuccess: 'Registration Successful',
        signin: 'Sign In',
        login: 'Login',
        finalizeAccount: 'Complete your profile',
        guardianData: 'Legal Guardian Data',
        forgotPassword: 'Reset password',
        institutionalAccess: 'How to access through your institution portal',
        searchResults: 'Search results',
        pageNotFound: 'Page not found',
        adjustImage: 'Adjust your picture',
        account: 'Profile',
        admin: 'Admin',
        help: 'Help',
        rate: 'Rate',
        rated: 'Rated',
        rateQuestion: 'What did you think of this content?',
        profileData: 'Personal Info.',
        permissions: 'Notifications and Permissions',
        plan: 'Subscription',
        config: 'Settings',
        mouse: 'Mouse',
        keyboard: 'Keyboard',
        trackpad: 'Trackpad',
        organs: 'Bodies and Systems',
        completeAnatomy: 'Complete\nAnatomy',
        topographicAnatomy: 'Topographic\nAnatomy',
        systemicAnatomy: 'Systemic\nAnatomy',
        cellStructure: 'Cells and tissues',
        cytology: 'Cytology',
        histology: 'Histology',
        histopathology: 'Histopathology',
        development: 'Bodily functions and development',
        embryology: 'Embryology',
        physiology: 'Physiology',
        specialties: 'Integrated Clinic',
        radiology: 'Radiology',
        pathology: 'Pathology',
        cadaverVirtual: 'Virtual Cadaver',
        api: 'BioAtlas API',
        institutions: 'Institutions',
        whiteLabel: 'White Label',
        VR: '3D Virtual Reality',
        multiplatform: 'Multiplataform',
        animations: '3D Interactive Animations',
        accessControl: 'Access Control',
        languages: 'Available in 3 languages',
        platform: 'Transform the way your institution teaches health sciences.',
        modules: 'Several modules for Health Education on a single platform',
        cadaver: 'Virtual Cadaver',
        cadaver3D: '3D Virtual Cadaver',
        atlas3D: '3D Anatomical Atlas',
        blades: 'Slides Histology and Histopathology',
        cardiacCycle: 'Cardiac Cycle of the Heart',
        fiberContraction: 'Muscle Fiber Contraction',
        potentialGeneration: 'Generation and Conduct of Action Potential',
        hematosis: 'Hematosis',
        synapticTransmission: 'Synaptic Transmission',
        lungVentilation: 'Lung Ventilation',
        pathophysiology: 'Pathophysiology',
        'pathologicalConditions.1': 'Acne',
        'pathologicalConditions.2': 'Pleural Conditions',
        'pathologicalConditions.3': 'Sickle Cell Anemia',
        'pathologicalConditions.4': 'Asthma',
        'pathologicalConditions.5': 'Ischemic Heart Disease',
        'pathologicalConditions.6': 'Spinal Deformities',
        'pathologicalConditions.7': 'Diabetes Mellitus Type 1',
        'pathologicalConditions.8': 'Diabetes Mellitus Type 2',
        'pathologicalConditions.9': 'Muscle Strain',
        'pathologicalConditions.10': "Graves' Disease",
        'pathologicalConditions.11': 'Peptic Ulcer Disease',
        'pathologicalConditions.12': 'Gastritis',
        'pathologicalConditions.13': 'Bone Fractures',
        'pathologicalConditions.14': 'Pneumonia',
        'pathologicalConditions.15': 'Polycystic Ovary Syndrome',
        'pathologicalConditions.16': 'Sinusitis',
        'pathologicalConditions.17': "Hashimoto's Thyroiditis",
        'pathologicalConditions.18': 'Thrombosis',
        'pathologicalConditions.19': 'Pulmonary Embolism',
        'pathologicalConditions.20': 'Tuberculosis',
        'pathologicalConditions.21': 'Urticaria',
        'histopathology.1': 'Respiratory System Diseases',
        'histopathology.2': 'Cardiovascular System Diseases',
        'histopathology.3': 'Digestive System Diseases',
        'histopathology.4': 'Blood Circulation Disorders',
        'histopathology.5': 'Tumor',
        'histopathology.6': 'Nervous System Diseases',
        'histopathology.7': 'Genital System Diseases',
        'histopathology.8': 'Urogenital System Diseases',
        'histopathology.9': 'Inflammation',
        'histopathology.10': 'Cell and Tissue Injury and Repair',
        'histopathology.11': 'Endocrine System Diseases',
        'histopathology.12': 'Immunological Diseases',
        'histopathology.13': 'Muscular and Skeletal System Diseases',
        'histopathology.14': 'Hematopoietic System Diseases',
        cardiology: 'Cardiology / Cardiac Emergencies',
        firstAid: 'First Aid',
        pulmonology: 'Pulmonology',
        infectology: 'Infectology',
        neurology: 'Neurology',
        vascular: 'Vascular',
        autoImmune: 'Rheumatism / Autoimmune',
        survey: 'Hi, will you help us improve BioAtlas?',
        collections: 'Collections',
        learningPaths: 'Paths',
        deleteCollections: 'Do you want to delete ',
        shareCollection: 'Share Contents for ',
        addToMyCollection: 'Add to my collection',
        explore: 'Explore',
        forTeachers: 'For Teachers',
        forStudents: 'For Students',
        app: 'App',
        contentCreationProcess: 'Content Creation Process',
        viewer3d: '3D Viewer',
        slideViewer: 'Slide Viewer',
        radiologyViewer: 'Radiology Viewer',
        biochemistry: 'Biochemistry',
        'features.collections': 'Collection Sharing',
        'features.multiplatform': 'Multiplatform',
        'features.laboratory': 'Reduced Laboratory Costs',
        'features.support': 'Research and Case Study Support',
        'features.integration': 'Integration',
        'features.languages': 'Available in 3 Languages',
        pathologicalConditions: 'Pathological conditions',
        'radiology.1': 'Computed Tomography (CT) Scans',
        'radiology.2': 'Magnetic Resonance Imaging (MRI)',
        'radiology.3': 'Computed Radiography (CR)',
        'radiology.4': 'X-rays',
        'radiology.5': 'Ultrasound',
        'cytology1.1': 'Virus',
        'cytology1.2': 'Bacterial Cell',
        'cytology1.3': 'Eukaryotic Cell of Animal Origin',
        'cytology1.4': 'Immune System Cell',
        'cytology1.5': 'Neuron',
        'cytology1.6': 'Adipose Cell',
        'cytology1.7': 'ABO System',
        'cytology1.8': 'Blood Cell',
        'cytology1.9': 'Muscle Fiber',
        'cytology1.10': 'Islets of Langerhans',
        'cytology1.11': 'Thyroid Follicle',
        'cytology2.1': 'Simple Diffusion',
        'cytology2.2': 'Facilitated Diffusion',
        'cytology2.3': 'Sodium-Potassium Pump',
        'cytology2.4': 'Cotransport',
        'cytology2.5': 'Countertransport',
        integrations: 'Integrations'
      },
      subtitles: {
        signup: 'Fill in the remaining information',
        validationSent: 'Information sent to email',
        signin: 'Fill in your information below.',
        finalizeAccount: 'Fill in the remaining information',
        fillInfo: 'Fill in the information below:',
        resetPassword: 'You need to change your password:',
        resetToken: 'Fill in the information to reset your password',
        selectInstitution:
          'Select your institution to see the specific tutorial.',
        pageNotFound: 'Sorry, there was an error on our page.',
        rightsReserved: 'All rights reserved.',
        aboutMedicalHarbour1:
          'BioAtlas is a product of Medical Harbour, a technology company that',
        aboutMedicalHarbour2:
          'develops digital solutions to facilitate health learning through interactive and 3D content.',
        aboutMedicalHarbour3:
          'Discover our solutions for Health Education institutions:',
        aboutMedicalHarbourDesktop1:
          'BioAtlas is a product of Medical Harbour, a technology company that develops solutions',
        aboutMedicalHarbourDesktop2:
          'digital solutions to facilitate health learning through interactive and 3D content. Discover our',
        aboutMedicalHarbourDesktop3:
          'solutions for Health Education institutions:',
        tabText: 'Interactive Digital Content for Health',
        group: 'We are an Afya Group company',
        sales: 'Contact our sales team',
        detail: 'Information',
        rotate: 'Rotate',
        moreTools: 'More tools',
        pin: 'Pin',
        ruler: 'Ruler',
        arrow: 'Arrow',
        savePin: 'Save pin',
        saveArrow: 'Save arrow',
        saveRectangle: 'Save rectangle',
        fullscreen: 'Full screen',
        info: 'Info',
        move: 'Move',
        select: 'Select',
        camera: 'Move camera',
        zoom: 'Zoom',
        resetZoom: 'Reset zoom',
        deselect: 'Delete selection',
        focus: 'Focus',
        selectMultiple: 'Select multiple',
        hide: 'Hide',
        help: 'Help',
        nextChapter: 'Next chapter',
        previousChapter: 'Previous chapter',
        save: 'Save',
        saveNew: 'Save new',
        animationPanel: 'Animation panel',
        recentralize: 'Recenter',
        undoAction: 'Undo action',
        advanceAction: 'Redo action',
        reset: 'Reset',
        playPause: 'Play/Pause',
        restartAnimation: 'Restart animation',
        speed: 'Speed',
        ClosePanelMinimize: 'Close panel/Minimize',
        basicTools: 'Basic tools',
        animationControl: 'Animation control',
        isolate: 'Isolate',
        tree: 'Anatomy tree',
        textbox: 'Text box',
        tag: 'Tag',
        cutTool: 'Cut tool',
        turn: 'Turn',
        menu: 'Menu',
        increaseZoom: 'Increase zoom',
        decreaseZoom: 'Decrease zoom',
        originalZoom: 'Reposition',
        bladeMessage:
          'For the keyboard shortcuts to work, click on the image first and then press the key',
        organ: 'Organ',
        tissue: 'Tissue',
        color: 'Coloring',
        section: 'Section',
        partners1: 'Join over',
        partners2: 'educational institutions in',
        partners3: 'countries around the world',
        completeAnatomy:
          'Offer the ultimate curriculum foundation in Human Anatomy.',
        completeAnatomy2: `Access the <b>Virtual Cadaver</b> and the <b>3D Atlas</b> for detailed navigation. This comprehensive module features <b>over 2,500 classified structures</b>, organized into 12 systems and 9 regions, available in both <b>Male and Female models</b>. Ensure <b>quality and standardization</b> in teaching across all Health Sciences disciplines.`,
        completeAnatomy3:
          'Human Anatomy is the science that studies the morphology and organization of the human body through the observation and analysis of its macroscopic constituent structures. This analysis is correlated with the functioning of the various parts and the mechanisms of formation and response to environmental, genetic, and temporal factors. It can be categorized, by separating its components, into Organ Systems and Anatomical Regions. In this module, representative anatomical models of the male and female bodies were included, in addition to the virtual male cadaver.',
        completeAnatomy4:
          'It features more than 2,500 labeled structures from all anatomical systems of the human body. This module is divided into Male and Female models and organized according to 12 anatomical systems and 9 regions.',
        completeAnatomy5:
          'A real human body* divided into 1,878 slices and photographed with ultra-high-resolution equipment, digitally reconstructed in 3D. The Virtual Cadaver has preserved colors, is segmented, and mapped for full visualization.',
        topographicAnatomy: 'The Anatomy Laboratory of the Future',
        topographicAnatomy2:
          'Transform Topographic Anatomy into an interactive and completely safe experience. By dividing the human body into regions, you will make it easier for students to understand the anatomical relationships between structures from all systems within a body segment.',
        topographicAnatomy3:
          'Topographic Anatomy deals with the study of the division of the human body into regions, in order to facilitate the understanding of anatomical relationships between structures of all systems in a given segment of the body. This method helps master the general topography of organs from the perception of the functioning and location of all nearby and related parts. In this module, the following anatomical regions were included: Descriptive Elements of the Skull, head and neck, right upper limb, left upper limb, back, thorax, abdomen, pelvis, right lower limb, and left lower limb.',
        systemicAnatomy: 'Comprehensive 3D Visualization and Active Learning',
        systemicAnatomy2:
          'With our 3D technology, students can explore all systems (skeletal, muscular, nervous, etc.) with clarity and precision, optimizing study time and enhancing content retention. This tool eliminates the need for additional expenses on specimens and models, ensuring teaching excellence without overburdening your institution’s budget.',
        systemicAnatomy3:
          'Systemic Anatomy deals with the analytical study of the organ systems of the human body, establishing sets of organs and anatomical structures that perform, in an integrated way, the same functions within biological mechanisms. Although each system carries out a distinct task, they are all interconnected, ensuring the functioning and survival of the organism as a whole. In this module, the following systems are considered: Arterial, Articular, Digestive, Endocrine, Skeletal, Lymphatic, Muscular, Nervous, Respiratory, Integumentary, Urogenital, and Venous.',
        cytology: 'The Virtual Laboratory that Optimizes Your Costs',
        cytology2:
          'Ensure efficiency and eliminate recurring laboratory expenses. The Cytology module allows detailed exploration of cellular structures with cutting-edge interactivity. With online access, there is no need for microscope maintenance, providing an active teaching tool that facilitates student success in the basic cycle.',
        cytology3:
          'The Cytology module allows users to interact with two categories of 3D content: Cells and the Cell Membrane. Explore the cells:',
        cytology4:
          'View a 3D model of the Cell Membrane and animations related to the transport of molecules across the membrane:',
        histology: 'Reduce Maintenance Costs and Provide Unlimited Practice',
        histology2:
          'The Histology module functions as a complete virtual microscopy laboratory, allowing various types of tissues, systems, and sensory organs to be explored with digital zoom and structure identification features, eliminating costs associated with slides and expensive equipment.',
        histology3:
          'The BioAtlas features a dedicated module for the study of slides, offering over 300 examples of glands, organs, tissues, and systems, as well as slides with pathologies. It also includes a tool with advanced visualization and analysis capabilities, allowing up to 40x zoom, slide annotation, mirroring, and more.',
        embryology: 'The Tool for Understanding Embryonic Development',
        embryology2:
          'Provide your students with a complete and interactive view of human development — from gamete formation to pregnancy and detailed placenta study. With immersive 3D features and content covering every embryonic and fetal stage, BioAtlas transforms complex subjects into accessible learning experiences, reducing laboratory costs and strengthening the quality of health education at your institution.',
        embryology3:
          'Follow embryonic and fetal development, from oogenesis/spermatogenesis to birth, through interactive 3D animations of the Embryonic Period of Development and the Fetal Period of Development.',
        physiology: 'More Success for Your Students in Every Exam',
        physiology2:
          'The Physiology module details the functioning of the human body and its developmental stages, allowing you to create dynamic collections and case studies that prepare students for clinical practice while strengthening the quality of your institution’s teaching.',
        physiology3:
          'Explore the functioning and normal functions of the human body through interactive 3D virtual content:',
        radiology: 'An Essential Tool for Diagnostic Reasoning',
        radiology2:
          'Prepare your students for clinical practice with the Radiology module, which enables interactive visualization of CT scans, MRIs, and X-rays, offering real images and the ability to compare exams. Promote content integration, turning learning into an active experience, and ensure your institution provides the most advanced resources in health education.',
        radiology3:
          'System for viewing DICOM images with tools for handling radiological studies and clinical cases. It allows viewing images from various modalities such as:',
        pathology:
          'Develop Your Students’ Clinical and Epidemiological Reasoning',
        pathology2:
          'The Pathology module, featuring virtual histopathological slides and interactive models, facilitates the study of various morphological and functional changes while preparing your students for clinical practice. Ensure your institution fosters the development of clinical and epidemiological reasoning.',
        pathology3:
          'This module features three-dimensional animations that depict unhealthy (pathological) physiological processes, highlighting the changes that occur in the body under these conditions.',
        features: 'Explore the details of the Human Body anytime, anywhere!',
        VR: 'Engage students and teachers through the immersive environment of Virtual Reality',
        multiplatform: 'Access via any web browser, Android or iOS app',
        animations:
          'Various content with guided 3D animations for easy understanding',
        accessControl: 'Enable, control and analyze teacher and student access',
        integration: 'Embed our content on your website through our API',
        languages:
          'Content mapped and translated into Portuguese, Spanish and English',
        testimonial0_0:
          'BioAtlas is an excellent tool for the student to integrate the different contents of biological and health sciences',
        testimonial0_1:
          'Professor of Human Physiology and Neuroscience at FMIT',
        newsletter:
          'Talk to our team and explore BioAtlas, designed to support and innovate within medical institutions.',
        platform:
          'BioAtlas brings together 3D human anatomy, virtual labs, collaborative teaching tools, and other interactive content in a single platform to deliver an immersive and efficient health learning experience.',
        modules:
          'A virtual environment with thousands of possibilities. Content related to the teaching of human anatomy, such as the 3D Virtual Human Anatomical Atlas, the 3D Virtual Cadaver, contents of Physiology, Histology, Embryology, Cytology, Medical Simulation and several others.',
        cadaver:
          'Have a 3D reconstruction of a real human body available for virtual dissection and complement the teaching of the anatomy laboratory.',
        cadaver3D:
          "The Virtual Cadaver illustrates the anatomy of a real male body, with its well-preserved proportions and structures that reveal the details of the organism's internal morphology. After freezing and dissecting the body, all anatomical parts were photographed and reconstructed in 3D in order to facilitate the visualization and study of human anatomy.",
        atlas3D:
          'The Human Atlas brings together the anatomical structures that represent the human body. Most parts are similar to those of the male and female body, such as the Respiratory, Digestive, Muscular, Articular, Skeletal, Lymphatic and Endocrine systems. In the Urogenital, Arterial, Venous, Nervous and Integumentary systems, some structures are different, characterizing each biological sex.',
        blades:
          'Over 200 digitized slides, being able to enlarge up to 40x, make markings, notes and much more!',
        contents1:
          'Explore the Human Body in detail through interactive 3D virtual models',
        contents2:
          'Content that makes the learning of human health disciplines easier through interactivity. It integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences and Social Sciences Applied to Health.',
        organs:
          'Learn about human anatomy interactively through the male and female anatomical atlases, and through the virtual cadaver - a 3D reconstruction of a real human body. The macroscopic study of the human body is organized in complete anatomy, which presents the systems and anatomical parts in an integrated way; systemic anatomy and topographic anatomy, which study structures that form organic systems and anatomical regions.',
        cellStructure:
          'Navigate the cells of the human body through interactive 3D models, exploring the organelles that make up the different cell types and their functions. In addition, a set of histological slides allows the user to microscopically view various body structures, such as glands, organs and tissues.',
        development:
          'Study human physiology and embryology through virtual three-dimensional content that explores different physiological processes and stages of embryonic and fetal development. Animated models allow the user to visualize and understand the functioning of the human body, in addition to following the stages of its development - from the 4th week of gestation to birth.',
        specialties:
          'Explore medical knowledge in a practical way from different perspectives. Radiology can be studied through DICOM images, with tools for handling clinical cases. Get to know the pathology module, which uses 3D virtual models and histological slides that allow the study of various morphological and functional alterations of the human body. Also, access the virtual simulator to experience emergency situations in the medical clinic in practice.',
        survey:
          'We are inviting you to fill out a short form, it is simple and quick.',
        successShareCollection: 'New emails with access:',
        errorShareCollection: 'An error happened in the following e-mails:',
        emailsWithAccess: 'Emails with access:',
        usersWithAccess: 'Users with access:',
        collectionsNotFound: 'Discover the full potential of Collections!',
        rating: 'What do you think could be improved?',
        'features.collections':
          'Optimize your time with personalized and shareable content, enhancing the quality of active learning.',
        'features.multiplatform':
          'Ensure unlimited access on any device (web, tablet, mobile), boosting student engagement and flexibility.',
        'features.laboratory':
          'Eliminate expenses on maintenance, models, and materials by investing in technology that maximizes your institution’s budget.',
        'features.support':
          'Provide advanced resources for developing case studies, strengthening research and innovation at your institution.',
        'features.integration':
          'Embed our content on your website through our API.',
        'features.languages':
          'Content mapped and translated into Portuguese, Spanish, and English.',
        histopathology:
          'This category includes hundreds of histological slides that show tissue and cell pathologies from various systems and anatomical regions of the human body.'
      },
      placeholders: {
        suggestion: 'Leave your comment',
        optionalSuggestion: 'Leave your comment (optional)',
        email: 'Enter your email',
        phone: 'Enter your phone',
        password: 'Enter your password',
        newPassword: 'Create your password',
        token: 'Enter code',
        name: 'Enter your name',
        lastName: 'Enter your last name',
        idNumber: 'Enter your ID (only numbers)',
        search: 'Search',
        searchTerms: 'Search by terms or titles',
        searchQuestion: 'What content do you want to study?',
        resultsFor: 'Search results for',
        find: 'Find',
        country: 'Enter your country',
        profession: 'Enter your occupation',
        countrySelect: 'Select your country',
        professionSelect: 'Select your occupation',
        institution: 'Enter your institution or company',
        departmentSelect: 'Pick a department',
        message: 'Type your message here',
        defaultCollectionTitle: 'No title',
        renameCollection: 'Add name for a new folder or template',
        moveCollection: 'Select the folder you want to move it to',
        shareCollection: 'Type the e-mail you want to share it with',
        createFolder: 'Type the name of the folder',
        newContent: "What's new"
      },
      labels: {
        email: 'Email',
        password: 'Password',
        newPassword: 'New Password',
        oldPassword: 'Current password',
        repeatPassword: 'Repeat Password',
        token: 'Enter the code received',
        firstName: 'First Name',
        lastName: 'Last Name',
        fullName: 'Full name',
        guardianName: "Legal Guardian's Name",
        guardianIdNumber: "Legal Guardian's ID Number",
        minorName: "Minor's Name",
        country: 'Country',
        profession: 'Occupation',
        institution: 'Company or Institution',
        department: 'Which departament do you want to talk to?',
        isAfya: 'Does your institution belong to the Afya Group?',
        message: 'Message',
        phone: 'Phone Number',
        mobile: 'Cell Phone Number',
        language: 'Language',
        pt: 'Português',
        es: 'Español',
        en: 'English',
        undefined: 'Undefined',
        description: 'Description',
        details: 'Details',
        forbidden: 'Module not released',
        account: 'Account',
        personalAccount: 'Personal Account',
        corporateAccount: 'Corporate Account',
        legal: 'Legal',
        useTerms: 'Terms of Use',
        politics: 'Privacy Policy',
        cookies: 'Cookies Policy',
        requests: "Holder's orders",
        dragFile: 'Drag or',
        uploadFile: 'upload your file here',
        availability: 'Available in:',
        contactWhats: '+55 11 96340-1024',
        contactEmail: 'sales@medicalharbour.com',
        module: 'Module',
        modules: 'Modules',
        newModule: 'New Module',
        new: 'New',
        updated: 'Updated',
        newContent: 'New content',
        step: 'Step',
        renameCollection: 'Name of folder or template',
        moveCollection: 'Move to',
        shareCollection: 'Share folder or template',
        createdAt: 'Created on',
        folderName: 'Folder name',
        directLink: 'Direct link',
        selectFolder: 'Content Location',
        '3d_contents': '3D Content',
        slides: 'Slides',
        shearchFolder: 'Search folders',
        addedAt: 'added on',
        myCollection: 'My Collections',
        myCollections: 'My Collection',
        collectionsSharedWithMe: 'Shared with Me',
        afyaCollections: 'Afya Collections',
        order: 'Order',
        recentsOrder: 'Most recent',
        alphabeticalOrder: 'Alphabetical',
        sortAlphabeticalAsc: 'Alphabetical (A-Z)',
        sortAlphabeticalDesc: 'Alphabetical (Z-A)',
        sortRelease: 'Most recently released',
        sortRelevance: 'Relevance',
        contentTypeOrder: 'Type',
        filter: 'Filter',
        type: 'Type',
        mostRecent: 'Most recent',
        recentViewedContents: 'Recently accessed content',
        weeklyTopContents: 'Most accessed this week',
        nextReleasesContents: 'Upcoming releases',
        notifyActivated: 'Notification activated!',
        notifyRelease: 'Notify me upon release',
        filterByModule: 'Filter by modules'
      },
      buttons: {
        signup: 'Register',
        signin: 'Begin session',
        enter: 'Enter',
        save: 'Save',
        cancel: 'Cancel',
        return: 'Back',
        exit: 'Exit',
        edit: 'Edit',
        update: 'Update',
        view: 'View',
        subscribe: 'Subscribe',
        send: 'Send',
        adjust: 'Adjust',
        remember: 'Remember me',
        sendData: 'Send Data',
        sendToken: 'Send reset e-mail',
        resendToken: 'Resend code',
        resetPassword: 'Reset password',
        changePassword: 'Change Password',
        changeProfile: 'Change Info.',
        changeLanguage: 'Change Language',
        changeAvatar: 'Change Photo',
        deleteAccount: 'Delete Account',
        confirmDelete: 'Delete anyway',
        cancelDelete: "Don't delete",
        viewPlan: 'Check all the services in your plan',
        finalizeAccount: 'Finalize Registration',
        navigation: 'Navegation Notions',
        shortcuts: 'Keyboard Shortcuts',
        demo: 'Request a Demo',
        discover: 'I want to learn about BioAtlas',
        openNewTab: 'Open in new tab',
        getNews: 'Receive news',
        knowMore: 'Learn more',
        knowContent: '$t(buttons.knowMore) about our content',
        knowModules: '$t(buttons.knowMore) about our modules',
        knowCadaver: '$t(buttons.knowMore) about the virtual cadaver',
        askDemo: 'Request a demo for your institution now.',
        askDemoNow: 'Request now the demo for your institution',
        requestPresentation: 'Request a presentation',
        surveyNo: 'No thanks',
        surveyYes: "Let's do the challenge",
        seeContent: 'See content',
        keepReading: 'keep reading',
        relatedContent: 'Related Content',
        bibliography: 'Bibliography',
        share: 'Share',
        rename: 'Rename',
        duplicate: 'Duplicate',
        move: 'Move',
        delete: 'Delete',
        createFolder: 'Create folder',
        sendFeedback: 'Send feedback',
        seeAll: 'see all',
        copyLink: 'Copy Link',
        linkCopied: 'Copied!',
        emailTab: 'Email',
        linkTab: 'Link',
        firstSteps: 'First steps',
        navigationAndShortcuts: 'Navigation and shortcuts',
        addNewEmails: 'Add new emails',
        close: 'Close',
        manageAccess: 'Manage access',
        addToCollection: 'Add to my collection',
        add: 'Add',
        startNow: 'Start now',
        applyFilter: 'Apply filter',
        accessPortal: 'How to access through your institution portal',
        universityPortal: 'How to access through the university portal',
        continueLogin: 'Continue trying to log in',
        needHelpAccess: 'Still need help accessing?',
        understood: 'Understood'
      },
      institutionSelection: {
        title: 'How to access through your institution portal',
        description: 'Select your institution to see the specific tutorial',
        canvasTitle: 'Canvas or Afya Access',
        canvasDescription:
          'For institutions using Canvas or Afya Access portal',
        othersTitle: 'Other institutions',
        othersDescription: 'For other institutional teaching platforms'
      },
      institutionTutorial: {
        canvas: {
          title: 'How to access via Canvas or Afya Access',
          steps: {
            1: "Access your university's Canvas portal",
            2: 'In the Courses tab, select an option',
            3: 'Find BioAtlas in the listed options',
            4: 'Now just click to access BioAtlas',
            5: 'BioAtlas will open automatically in your browser'
          }
        },
        other: {
          title: "How to access via your institution's learning platform",
          steps: {
            1: "Access your university's learning platform",
            2: 'Find BioAtlas in the listed options',
            3: 'Now just click to access BioAtlas',
            4: 'BioAtlas will open automatically in your browser'
          }
        }
      },
      separators: {
        or: 'Or'
      },
      messages: {
        conjunction: 'and',
        separator: 'or',
        optional: 'optional',
        agreeTerms1:
          'By registering, I agree that I have read and accepted the',
        agreeTerms2: 'I agree that I have read and accept the',
        agreeTermsMinorS:
          'I am over 18 years old and aware of the responsibilities.',
        agreeTermsMinorL:
          'I am under 18 years old and my legal guardian authorizes Medical Harbor to collect my personal data for the purposes of electronic communications of offers and services (SMS, instant messages, telephone, e-mail) in accordance with the $t(labels.politics).',
        validationSent: 'We sent you an email to validate your registration!',
        contactAdmin: 'Please contact the admin of your system!',
        accountReady: 'Your access to BioAtlas is active!',
        dataSharing: 'Accept sharing your data for product offers',
        notifications:
          'Accept receiving notifications via SMS, Whatsapp or email?',
        deleteQuestion:
          'Are you sure you want to permanently delete your account?',
        deleteReminder1:
          'Deleting your BioAtlas account is a permanent action and cannot be undone.',
        deleteReminder2:
          "Once you delete your account, you will not be able to log back into the app, and any 3D models you've created and saved in your Library will be removed from our database permanently and cannot be restored.",
        trialWarning:
          'You are using the trial version. You still have {{count}} day left.',
        trialWarning_plural:
          'You are using the trial version. You still have {{count}} days left.',
        trialUpgrade: 'Obtain PRO version.',
        noContent:
          'No results found for the selected filters. Try adjusting or removing some filters to view content.',
        newContent: 'New content that may interest you',
        noAccount: "Don't have an account yet?",
        gotAccount: 'Already have an account?',
        passwordsDontMatch: 'Passwords must be equals!',
        notYetValidated:
          "You haven't validated your registration through the email yet!",
        notYetConfirmed:
          'You have not confirmed your registration yet. Please, check your email.',
        confirmAccount: 'Confirm your BioAtlas account',
        notYetConfirmed1: 'Before changing your password,',
        notYetConfirmed2: 'Before logging in,',
        notYetConfirmed3: 'confirm your account with the email we sent.',
        notYetConfirmed4: "Don't forget to check your spambox too, ok?",
        checkData: 'Check your details and try again',
        loginInvalid: 'Invalid username and/or password',
        userNotFound: 'User not found',
        userNotFoundInstitutional:
          "Can't log in? You may be trying to access with an institutional account.",
        wrongPassword: 'Password is incorrect',
        tooManyRequests:
          'You made too many requests. Please wait a moment and try again.',
        tooManyFailedAttempts: 'You failed several retries',
        tooManyAttempts: 'You have exceeded your retry limit',
        tokenSent: 'Code sent to email: {{email}}',
        passwordChanged: 'Password changed successfully!',
        tokenInvalid: 'Invalid code. Please request a new one.',
        passwordTooShort: 'Password must be at least 8 characters long',
        tryAgain:
          'There was a problem submitting your information. Please try again!',
        partialSuccessData:
          'Your profile data was updated successfully, but there was a problem submitting your picture.',
        partialSuccessImg:
          'Your picture was updated successfully, but there was a problem submitting your profile info.',
        requiredField: 'Required field',
        invalidEmail: 'Please enter a valid email',
        emailExists: 'An account already exists with this email',
        phoneExists: 'This phone number is already registered',
        phoneTooShort: 'Invalid phone number.',
        idTooShort: 'Invalid ID number.',
        dataUpdated: 'Info. updated successfully!',
        collectionDeleted: 'Collection deleted successfully!',
        alreadySignedUp:
          'You have already created an account, login with your username and password!',
        invalidLink:
          'This link is not valid, please contact your administrator!',
        finalizeLinkAlreadyUsed:
          'This account finalization link has already been used.',
        multipleImages: 'Send only one file',
        imageType:
          'This file type is not supported. Valid extensions: {{support}}',
        imageSize:
          'This file is too big! ({{size}}) Maximum upload size is {{limit}}.',
        agreement:
          'You must accept the $t(labels.useTerms) and the $t(labels.politics)',
        guardianData:
          'As you are a minor, you need to enter the $t(titles.guardianData)',
        unreachable:
          'Our server is experiencing technical difficulties. Please try again later.',
        accessDenied: 'Please login again.',
        unverifiedEmail: 'Error: email not verified',
        autoLogin: 'We are logging you in.',
        copySuccess: 'Copied to clipboard!',
        copyError: 'There was an error copying!',
        unexisting: 'Content does not exist',
        unavailable: 'Content not available',
        betterExp:
          'For a better experience, access our application or Desktop version',
        desktop: 'Desktop',
        appAvailable: 'Download the BioAtlas app from the stores',
        support1: 'Please contact our',
        support2: 'support team',
        crash: 'Something went wrong with BioAtlas. $t(messages.support1)',
        appDenied:
          "It seems that you don't have access to BioAtlas. $t(messages.support1)",
        contactSuccess1: "Hi! We've just received your message!",
        contactSuccess2:
          "We're thrilled to hear that you want to talk to us. Thank you very much for your interest in BioAtlas.",
        contactSuccess3:
          "We're reviewing your message and will contact you shortly to respond to your questions and comments.",
        whichContents: "Chapters you'll access:",
        errorCollection:
          "I'm sorry, an error happened when trying to get your collections",
        emptyCollections:
          "It looks like you don't have any collections yet. Choose any 3D model, customize it and save ;)",
        emptyCollectionsMobile:
          "It looks like you don't have any collections yet. Access your app to view your collections.",
        emptyCollectionsShared:
          'No collections have been shared with you yet. When someone shares one, it will appear here.',
        collectionRenamed: 'Collection renamed successfully!',
        folderRenamed: 'Folder renamed successfully!',
        collectionMoved: 'Collection moved successfully!',
        collecionDeleted: 'Collection deleted successfully!',
        collecionShared: 'Collection shared successfully!',
        collectionUnshared: 'Collection was removed from user successfully!',
        collectionDuplicated: 'Collection duplicated successfully!',
        collectionFolderCreated: 'Folder created successfully!',
        collectionFolderDuplicateErr: 'Folder with this name already exists',
        demoPopUpText1: 'You have ',
        demoPopUpTextDays: 'day ',
        demoPopUpTextDaysPlural: 'days ',
        demoPopUpTextMonths: 'month ',
        demoPopUpTextMonthsPlural: 'months ',
        demoPopUpText2: 'left on your demo access',
        demoPopUpText3: ', your opinion about the platform is very important',
        demoExpiredText:
          'Your demo license has expired. Please contact our support.',
        demoExpiredBtn: 'Chat with our team',
        errorInputShared:
          'It is not possible to share the collection with this email',
        by: 'By',
        deleteCollectionMsgSingular:
          'When deleting this folder the following collection or folder will also be deleted:',
        deleteCollectionMsgPlural:
          'When deleting this folder the following models or collections will also be deleted:',
        folderNotFound: 'Folder not found',
        newContentTitle: 'Check out the latest news from BioAtlas',
        newContentSubtitle: 'New tool to save your collections',
        newContentText:
          'Now you can create a custom collection of 3D content. With BioAtlas, you can save these models, organize them into folders and share them simply and quickly with your friends and students.',
        newContentClose: 'Close',
        to: 'to',
        thankYouRating: 'Thank you for your rating',
        pickRateError:
          'Please, pick a rating for this content or change your previous rate/comment before submitting',
        shareCollectionErrorTitle: 'Error retrieving collection',
        shareCollectionErrorText:
          'It was not possible to access the collection that was shared with you. You will be redirected to the homepage',
        expiredCollectionLinkErrorTitle: 'Expired link',
        expiredCollectionLinkErrorText:
          'Get a new link to access this collection. You will be redirected to the homepage',
        clipboardPermissionsErrorTitle: 'Could not copy the link',
        clipboardPermissionsErrorText:
          "Check the site's permissions for the clipboard and try again",
        saveCollectionSuccessTitle: 'Content added',
        saveCollectionSuccessText:
          'The content has been successfully added to your collection',
        saveCollectionErrorTitle: 'Error saving content to collections',
        saveCollectionErrorText:
          'The content could not be saved at the moment. Please try again later',
        lockedItem: 'Institutional content locked',
        lockedFolderNoCreate:
          'You can’t create folders inside institutional collections.',
        notFoundContentForTerm: 'No content was found for the term',
        trySimilarTerms: 'Try using similar words or check the spelling.',
        relatedContentsTerm: 'Related content to the term'
      },
      swal: {
        success: 'Success',
        warning: 'Attention',
        error: 'A problem has ocurred!',
        access: 'You do not have access',
        crash: 'Oops!!!'
      },
      banner: {
        title: 'Did You Know?',
        curiosity1:
          'The human brain contains on average 86 billion neurons. Only 19% of them are located in cerebral cortex, while the cerebellum contains 80%. The remaining cells are found in the brainstem.',
        curiosity2:
          'The human body literally glimmers. This process consists of a ultraweak biophoton emission, energy released as light through the biochemical reactions in cell metabolism. The intensity of the light emitted by the body is lower than the sensitivity of our naked eyes, that’s why we cannot see it.'
      },
      alts: {
        load: 'Loading animation',
        logo: 'BioAtlas logo',
        eye: 'Eye icon for enabling password visibility',
        avatar: "User's profile picture",
        edit: 'Edit icon',
        computer: 'Image of a computer alerting that an email has arrived',
        check: 'Check icon animation',
        folder: 'Folder',
        home: 'Home',
        playstore: 'Playstore Image',
        appstore: 'Appstore Image'
      },
      modules: {
        cytology: 'Cytology',
        transports: 'Membrane Transport',
        histology: 'Histology',
        systemicAnatomy: 'Systemic Anatomy',
        topographicAnatomy: 'Topographic Anatomy',
        completeAnatomy: 'Complete Anatomy',
        physiology: 'Physiology',
        embryology: 'Embryology',
        radiology: 'Radiology',
        pathology: 'Pathology',
        histopathology: 'Histopathology'
      },
      categories: {
        all: 'All',
        tissues: 'Tissues',
        systems: 'Systems',
        organs: 'Sensory Organs',
        atlas: 'Human Atlas',
        atlas2: 'Anatomical Atlas',
        cadaver: 'Virtual Cadaver'
      },
      improvements: {
        exam_quality: 'Exam quality',
        exam_report: 'Exam report',
        features: 'Features',
        usability_navigation: 'Usability/Navigation',
        other_reason: 'Other reason (comment below)',
        text: 'Text',
        slide_quality: 'Slide quality',
        information_consistency: 'Information consistency',
        sample: 'Sample',
        structure_identification: 'Structure identification',
        morphology: 'Morphology',
        loading: 'Loading',
        content_depth: 'Content depth'
      },
      subCategories: {
        epithelial: 'Epithelial Tissue',
        connective: 'Connective Tissue',
        circulatory: 'Circulatory',
        articular: 'Articular',
        digestive: 'Digestive',
        endocrine: 'Endocrine',
        skeletal: 'Skeletal',
        integumentary: 'Integumentary',
        lymphoid: 'Lymphoid',
        muscular: 'Muscular',
        nervous: 'Nervous',
        respiratory: 'Respiratory',
        urogenital: 'Urogenital',
        male: 'Male',
        female: 'Female'
      },
      helpers: {
        rotateMouse: 'Hold the left mouse button and move to rotate the object',
        moveMouseBlade: 'Hold the left mouse button and drag to move the slide',
        moveMouseModel:
          'Hold the right mouse button to move the object on the screen',
        selectMouse: 'Left click once to select a structure',
        zoomMouse: 'Use the mouse scroll wheel to increase or decrease zoom',
        textboxMouse:
          'Press shift on the keyboard, click and drag the left mouse button',
        cameraKeyboard:
          'Use the (W) key to move up, (S) key to move down, (A) key to move left and (D) key to move right',
        rotateKeyboard:
          'Use the (↑) key to rotate up, (↓) key to rotate down, (←) key to rotate left and (→) key to rotate right',
        zoomKeyboard: 'Use the + and - keys to apply zoom',
        moveKeyboard: 'Use the arrow keys to move the slide',
        rotatePad: 'Hold the left trackpad button and move to rotate',
        movePad: 'Hold the right trackpad button and move the object camera',
        zoomPad: 'Left click once to select a structure'
      },
      home: {
        banner: {
          title:
            '3D Interactive Virtual Content for Teaching in the HealthCare Area',
          subtitle:
            'Explore 3D interactive digital content for Teaching Basic Health Cycle through a web browser, Android/iOS App and Virtual Reality glasses'
        },
        specs: {
          title:
            'Browse through the details of the Human Body anytime, anywhere!',
          item1: 'Multiplatform Access',
          text1:
            'Access through any web browser, Android or iOS app, no plugins required, no installation required',
          item2: 'Access Control',
          text2: 'Enable, control and analyze teacher and student access',
          item3: 'Available in 3 languages',
          text3:
            'Content mapped and translated into Portuguese, Spanish and English',
          item4: 'Integration',
          text4: 'Embed our content on your website via our API',
          item5: '3D Interactive Animations',
          text5:
            'Diverse content with guided 3D animations for easy understanding',
          item6: '3D Virtual Reality',
          text6:
            'Engage students and teachers through the immersive environment of Virtual Reality'
        },
        minibanner: 'Reduce the Anatomy lab costs',
        allInOne: {
          title:
            'A multiplatform suite for accessing an Interactive Digital Library of 3D content for Health Education',
          text: 'BioAtlas is a solution that adapts to various technological tools on the market and allows browsing through 3D Interactive Digital Content for health using any web browser or mobile app Android or iOS and Virtual Reality Glasses'
        },
        teaser: 'Find out more about BioAtlas',
        dashboard: {
          title: 'Dashboard with data for tracking usage indicators',
          subtitle:
            'More intelligence to monitor system usage and results in your favor',
          text1:
            'Analyze usage, engagement, performance and other key metrics to improve learning',
          text2: 'Gain insights from user interactions'
        },
        quotes: {
          text1:
            'BioAtlas is an excellent tool for the student to integrate the different contents of biological and health sciences',
          position: 'Professor of Human Physiology and Neuroscience at FMIT'
        },
        carousel: {
          startHere: {
            title: "Don't know where to start?",
            description:
              'Afya collections contain curated and organized content for you.',
            button: 'Access Afya collections'
          },
          collections: {
            title:
              'Want to share your personalized studies in a simple and organized way?',
            description:
              'Create a collection and share it with whoever you want!',
            button: 'Access collections'
          },
          suggestions: {
            title: "Didn't find what you needed?",
            description:
              'Your suggestion can inspire the next contents on the platform.',
            button: "Let's go!"
          }
        },
        conclusion:
          "Learn about BioAtlas, its possibilities, and ensure your Institution's knowledge of Health in any learning scenario.",
        'footerBannerSubtitle.1': 'BioAtlas is also in your pocket.',
        'footerBannerSubtitle.2':
          'Download the app and take your studies with you!'
      },
      contentTypes: {
        unity: '3D Content',
        slide: 'Slides',
        dicom: 'Images'
      },
      contents: {
        banner: {
          title:
            'Explore the Human Body in detail through interactive 3D virtual models',
          subtitle:
            'BioAtlas allows you to navigate through the human body in a fully interactive virtual way using any web browser, smartphone or Virtual Reality glasses.',
          obs: '*Available in 3 languages: Portuguese, English and Spanish'
        },
        systems: {
          title: 'Human body systems',
          completeAnatomy: {
            text1:
              'has more than 2500 labeled structures of all anatomical systems of the human body. This module is separated into Male and Female models and organized according to 12 anatomical systems and 9 regions.',
            text2:
              'is a 3D reconstruction of a real human body that was donated for research*. It was frozen, divided into 1878 slices and photographed with very high resolution equipment. The Virtual Cadaver has preserved colors, is segmented and mapped for complete viewing.',
            obs1: '*The 3D version in Virtual Reality - VR - is an immersive way to understand and understand the human body one step away from the metaverse.',
            obs2: '*Learn more about the Visible Human Project'
          },
          topographicAnatomy: {
            text: 'Navigate through the Anatomical Landmarks of Skull and through anatomical regions: head and neck, right upper limb, left upper limb, back, chest, abdomen, pelvis, right lower limb and left lower limb.'
          },
          systemicAnatomy: {
            text: 'Anatomical systems: integumentary, muscular, skeletal, articular, nervous, lymphatic, digestive, respiratory, arterial, venous, endocrine and urogenital.'
          },
          physiology: {
            text: 'Explore the normal functioning and functions of the human body through interactive 3D virtual content:',
            item1: 'Heart Cycle',
            item2: 'Muscle fiber contraction',
            item3: 'Generation and Conduction of Action Potential',
            item4: 'Gas Exchange',
            item5: 'Synaptic Transmission',
            item6: 'Pulmonary Ventilation'
          }
        },
        cellStructure: {
          title: 'Cell structure and microanatomy',
          cytology: {
            title: '3D Cytology',
            text: 'The Cytology module allows the user to interact with two categories of 3D content: Cells and Cell Membrane. Navigate through the cells: Eukaryotic Cell of Animal Origin, Blood Cell, Neuron and Muscle Fiber. Visualize a 3D Cell Membrane model with five animations related to the transport of molecules across the membrane:',
            item1: 'Simple Diffusion',
            item2: 'Facilitated Diffusion',
            item3: 'Sodium and potassium pump',
            item4: 'Co-transport',
            item5: 'Countertransport'
          },
          histology: {
            text: 'BioAtlas has a module dedicated to the study of slides of glands, organs, tissues and systems, and slides with pathologies. In addition to having a tool with resources for viewing and analyzing them.'
          }
        },
        development: {
          title: 'Human development',
          embryology: {
            text: 'Visualize embryonic and fetal development, from the 4th week of gestation to birth, through interactive 3D animations.'
          }
        },
        specialties: {
          title: 'Medical specialties',
          radiology: {
            text: 'DICOM image visualization system with tools for handling radiological clinical studies and cases. It allows you to view images of different modalities such as CT scans, MRIs, X-Rays, among others, through the web browser.'
          }
        },
        collections: {
          notFound:
            'Watch the video below and see, in practice, how each feature can transform your study experience and the way you explore content.'
        },
        conclusion: 'Get in contact to learn about BioAtlas'
      },
      onboarding: {
        steps: {
          step1:
            'Step 1: We want to get to know you better! Which health area do you identify with most?',
          step2: 'Step 2: Specialty or Main Interest',
          step3: 'Step 3: Moment in Career or Training',
          step4: 'Step 4: Main Objective in BioAtlas',
          step5: 'Step 5: Learning Preference',
          step6: 'Step 6: Available Weekly Time'
        },
        auxiliaryTexts: {
          step1: 'Choose only one area.',
          step2:
            'What is your specialty or area of ​​interest? (If you dont have one, you can choose "General interest")',
          step3: 'What stage of your journey are you at?',
          step4: 'What are you looking for on the platform?',
          step5: 'How do you prefer to learn?',
          step6: 'How much time do you dedicate to studying each week?'
        },
        buttons: {
          skip: 'Skip and do later',
          continue: 'Continue',
          finish: 'Finish and access BioAtlas',
          back: 'Back'
        },
        stepBar: {
          of: '{{step}} of {{totalSteps}}'
        },
        healthAreas: {
          medicine: 'Medicine',
          nursing: 'Nursing',
          pharmacy: 'Pharmacy',
          physiotherapy: 'Physiotherapy',
          nutrition: 'Nutrition',
          biomedicine: 'Biomedicine',
          dentistry: 'Dentistry',
          physical_education: 'Physical Education',
          others: 'Others'
        },
        specialties: {
          medicine: {
            clinical_medicine: 'Clinical Medicine',
            pediatrics: 'Pediatrics',
            general_surgery: 'General Surgery',
            gynecology_obstetrics: 'Gynecology / Obstetrics',
            cardiology: 'Cardiology',
            orthopedics: 'Orthopedics',
            dermatology: 'Dermatology',
            emergency: 'Emergency Medicine',
            geriatrics: 'Geriatrics',
            ophthalmology: 'Ophthalmology',
            pathology: 'Pathology',
            general_interest: 'General Interest',
            others: 'Others'
          },
          nursing: {
            medical_surgical_nursing: 'Medical-Surgical Nursing',
            pediatric_nursing: 'Pediatric Nursing',
            obstetric_nursing: 'Obstetric Nursing',
            mental_health_nursing: 'Mental Health Nursing',
            emergency_nursing: 'Emergency Nursing',
            geriatric_nursing: 'Geriatric Nursing',
            public_health_nursing: 'Public Health Nursing',
            occupational_nursing: 'Occupational Nursing',
            others: 'Others'
          },
          pharmacy: {
            hospital_pharmacy: 'Hospital Pharmacy',
            clinical_pharmacy: 'Clinical Pharmacy',
            clinical_analysis: 'Clinical Analysis',
            pharmaceutical_industry: 'Pharmaceutical Industry',
            community_pharmacy: 'Community Pharmacy',
            compounding_pharmacy: 'Compounding Pharmacy',
            toxicology: 'Toxicology',
            pharmacovigilance: 'Pharmacovigilance',
            cosmetology: 'Cosmetology',
            others: 'Others'
          },
          physiotherapy: {
            neurological_physiotherapy: 'Neurological Physiotherapy',
            respiratory_physiotherapy: 'Respiratory Physiotherapy',
            cardiovascular_physiotherapy: 'Cardiovascular Physiotherapy',
            dermatofunctional_physiotherapy: 'Dermatofunctional Physiotherapy',
            geriatric_physiotherapy: 'Geriatric Physiotherapy',
            pediatric_physiotherapy: 'Pediatric Physiotherapy',
            women_health_physiotherapy: "Women's Health Physiotherapy",
            sports_physiotherapy: 'Sports Physiotherapy',
            others: 'Others'
          },
          nutrition: {
            clinical_nutrition: 'Clinical Nutrition',
            sports_nutrition: 'Sports Nutrition',
            public_health_nutrition: 'Public Health Nutrition',
            maternal_child_nutrition: 'Maternal-Child Nutrition',
            geriatric_nutrition: 'Geriatric Nutrition',
            hospital_nutrition: 'Hospital Nutrition',
            others: 'Others'
          },
          biomedicine: {
            clinical_analysis: 'Clinical Analysis',
            molecular_biology: 'Molecular Biology',
            radiology_diagnostic_imaging: 'Radiology / Diagnostic Imaging',
            microbiology: 'Microbiology',
            immunology: 'Immunology',
            hematology: 'Hematology',
            blood_bank_hemotherapy: 'Blood Bank / Hemotherapy',
            genetics: 'Genetics',
            parasitology: 'Parasitology',
            aesthetics: 'Aesthetics',
            others: 'Others'
          },
          dentistry: {
            dental_aesthetics_restorative: 'Dental Aesthetics/Restorative',
            endodontics: 'Endodontics',
            periodontics: 'Periodontics',
            oral_maxillofacial_surgery: 'Oral and Maxillofacial Surgery',
            orthodontics: 'Orthodontics',
            pediatric_dentistry: 'Pediatric Dentistry',
            dental_prosthetics: 'Dental Prosthetics',
            dental_radiology: 'Dental Radiology',
            oral_pathology: 'Oral Pathology',
            others: 'Others'
          },
          physical_education: {
            school_physical_education: 'School Physical Education',
            sports_training: 'Sports Training',
            physical_activity_health: 'Physical Activity and Health',
            recreation_leisure: 'Recreation and Leisure',
            bodybuilding_conditioning: 'Bodybuilding / Conditioning',
            rehabilitation_therapeutic_exercise:
              'Rehabilitation/Therapeutic Exercise',
            workplace_gymnastics: 'Workplace Gymnastics',
            psychomotricity: 'Psychomotricity',
            special_populations_physical_activity:
              'Physical Activity for Special Populations',
            others: 'Others'
          },
          others: {
            general_interest: 'General Interest',
            others: 'Others'
          }
        },
        academicLevels: {
          student: 'Undergraduate student',
          resident: 'Resident / Graduate student',
          professor: 'Professor / Researcher'
        },
        semesters: {
          '1-2': '1st - 2nd semester',
          '3-4': '3rd - 4th semester',
          '5-6': '5th - 6th semester',
          '7+': '7th+ semester'
        },
        objectives: {
          study: 'Follow university subjects',
          pass_exams: 'Pass exams (residency, competition)',
          practical: 'Learn practical skills',
          personal_interest: 'Explore new content out of personal interest'
        },
        learningPreferences: {
          videos: 'Videos',
          summaries: 'Organized summaries',
          articles: 'Articles',
          clinical_cases: 'Clinical cases and exercises',
          audios: 'Podcasts and audio classes',
          study_group: 'Study groups and forums'
        },
        weeklyTime: {
          '3h': 'Little time (Up to 3h/week)',
          '4-7h': 'Some hours (4 to 7h/week)',
          '8h': 'A lot of time (8h or more)'
        },
        subtexts: {
          healthAreaOthers:
            'Want to explore other health areas? Write your preferences here!',
          specialtyOthers:
            'Want to explore other specialties? Write your preferences here!',
          semesterTitle: 'Year / Semester:'
        },
        tempContent: {
          stepContent: 'Content of {stepText}',
          tempArea:
            'This is a temporary area for the specific content of each step.'
        },
        editBanner: {
          title: 'How about completing your profile?',
          subtitle:
            'This way, we better understand your interests and preferences.',
          editProfile: 'Edit my profile',
          letsGo: "Let's go"
        }
      },
      integration: {
        banner: {
          title: 'Add BioAtlas 3D interactivity to your content',
          subtitle:
            'Bring your healthcare project to life by adding your brand to BioAtlas or by embedding our animations, interactive virtual pieces through BioAtlas API integration.'
        },
        api: {
          label: 'BioAtlas API',
          title: 'BioAtlas 3D content in your project via our API',
          subtitle:
            'Build a 3D virtual interactive experience in your project related to anatomy or other disciplines related to the basic cycle in Health. BioAtlas content can be easily integrated into your website, digital content, LMS or digital project through the BioAtlas API.'
        },
        institutions: {
          label: 'Institutions',
          title: 'BioAtlas for your institution',
          item1: 'Pharmaceutical',
          item2: 'Universities',
          item3: 'Hospitals',
          item4: 'Publishers'
        },
        whiteLabel: {
          label: 'White Label',
          title: "BioAtlas with your Institution's brand",
          subtitle:
            'BioAtlas has a “Private Label” solution, which allows you to brand your Institution, making it a 100% customized solution.'
        }
      },
      contactPage: {
        form: {
          step: 'Step',
          of: 'of',
          select: 'Select',
          title: 'Request your free BioAtlas demo now',
          previousButton: 'Back',
          nextButton: 'Continue',
          submitButton: 'Submit request',
          submitting: 'Loading...',
          businessEmail: 'Enter your business email',
          allowReceiveEmails: 'I agree to receive updates via email',
          fullName: 'Great! Now, enter your full name',
          phone: 'Well done! Now, enter your phone number / WhatsApp',
          institutionName: 'What is the name of your institution?',
          profession: 'What is your position or profession?',
          professions: {
            coordinator: 'Course Coordinator',
            professor: 'Professor',
            student: 'Student',
            others: 'Others'
          },
          privacyPolicy: {
            text: 'By submitting my personal data, I authorize BioAtlas to collect, process, and store my information in accordance with the Privacy Notice, as described in the ',
            link: 'BioAtlas Privacy Notice.'
          },
          success: {
            header: 'Your demo request has been successfully submitted!',
            label: 'We’ll be in touch shortly to schedule your BioAtlas demo.'
          },
          error: {
            header: 'An error occurred while submitting your information.',
            label: 'Please try again later.'
          }
        },
        contentSuggestion: {
          title: 'What content would you like to study on BioAtlas?',
          moduleLabel: 'Which BioAtlas module does this content fit into?',
          modulePlaceholder: 'Select the module',
          titleLabel: 'Content title or theme',
          titlePlaceholder: 'E.g.: Heart embryology, Clinical trauma cases',
          detailsLabel: 'Additional details (optional)',
          detailsPlaceholder:
            'Describe what you would like to see or how this content could help',
          submitting: 'Submitting...',
          submit: 'Submit suggestion',
          successMessage:
            'Your suggestion has been sent successfully! Thank you for contributing to BioAtlas.'
        }
      },
      landingV2: {
        heroBanner: {
          title: 'An ecosystem of tools for health education',
          subtitle:
            'BioAtlas contributes to the improvement of teaching work and the student learning process.',
          button: 'Request presentation',
          note: '*BioAtlas is exclusive to Educational Institutions'
        },
        sectionAppBioAtlas: {
          title:
            "BioAtlas also has an exclusive application for your institution's users",
          downloadText: 'Available for download at',
          button: 'Learn more about the App'
        },
        sectionCtaBioAtlas: {
          text: 'Discover how BioAtlas transforms teaching.<br/>Request a free presentation and explore this<br/>innovation in action!',
          button: 'Request presentation'
        },
        sectionCtaCytology: {
          text: 'Elevate medical teaching and learning<br/>with BioAtlas.',
          button: 'Request presentation'
        },
        sectionEnriquecaAulas: {
          title: 'Enrich your human health classes with our content',
          blocks: {
            visualizacao: {
              title: 'Interactive 3D Visualization',
              text: 'We recognize that effective learning about the human body and its complexities requires more than just memorizing terms. To improve the understanding of human health education, BioAtlas offers an innovative and immersive approach.'
            },
            integracao: {
              title: 'Integration',
              text: 'Make cuts and save specific sections of the available content, delimiting the information of interest according to your research or study needs.'
            },
            customizacao: {
              title: 'Custom Visualization',
              text: 'It is possible to make cuts, sections, and save customized content in collections.'
            }
          }
        },
        sectionEstudanteProfissional: {
          title: 'From student to professional',
          subtitle: 'a complete solution for health education',
          bullets: {
            otimizacao: {
              title: 'Cost optimization - ',
              text: 'Significant reduction of expenses with the maintenance of laboratories, anatomical parts, and complex physical structures.'
            },
            potencializacao: {
              title: 'Results Enhancement - ',
              text: 'BioAtlas improves learning, engagement, student retention, and performance in assessments, including those of the Ministry of Education (MEC)'
            },
            recurso: {
              title: 'Essential Pedagogical Resource - ',
              text: 'An educational resource that supports active methodologies, sharing of collections, and practical preparation for daily teaching.'
            },
            praticidade: {
              title: 'Practicality - ',
              text: 'Facilitates teaching work, centralizing all resources in a single tool.'
            },
            disponivel: {
              title: 'Available wherever you are - ',
              text: 'Multiplatform content, available in web and mobile environments, allowing downloads and studying inside and outside the classroom.'
            }
          }
        },
        sectionModulosBioAtlas: {
          title:
            'Discover our modules for a complete in-depth study of the human body',
          fallbackText: 'Image coming soon',
          knowMore: 'Learn more',
          modules: {
            histologia: 'Histology',
            patologia: 'Pathology',
            histopatologia: 'Histopathology',
            radiologia: 'Radiology',
            fisiologia: 'Physiology',
            embriologia: 'Embryology',
            citologia: 'Cytology',
            anatomiaTopografica: 'Topographic Anatomy',
            anatomiaSistemica: 'Systemic Anatomy',
            anatomiaCompleta: 'Complete Anatomy',
            cadaverVirtual: 'Virtual Cadaver'
          }
        },
        sectionResults: {
          title: 'Results that make a difference',
          cards: {
            alunos: { text1: 'Used by more than', text3: 'students' },
            instituicoes: {
              text1: 'Present in',
              text2: 'more than',
              text3: 'Educational Institutions'
            },
            conteudos: { text1: 'More than', text3: 'Interactive contents' }
          }
        },
        sectionSolucaoBioAtlas: {
          title:
            'BioAtlas: A robust solution designed for all members <br /> of your human health Educational Institution',
          altProfessores: 'Solution for Teachers',
          altAlunos: 'Solution for Students',
          professores: {
            title: 'For Teachers:',
            list: [
              'Visual and updated content to engage students',
              'Create and share content collections',
              'Multiplatform access (mobile, computer, tablet)',
              'Simple training',
              'Integration with institutional platforms'
            ],
            button: 'Learn more',
            staticTitle: 'For teachers',
            staticSubtitle: 'Learn more'
          },
          alunos: {
            title: 'For students:',
            list: ['Easy sharing of collections.', 'Multiplatform access'],
            button: 'Learn more',
            staticTitle: 'For students',
            staticSubtitle: 'Learn more'
          }
        },
        sectionVantagensInstituicao: {
          title: 'BioAtlas Advantages for your Institution',
          buttons: {
            acesso: 'Access',
            multilingue: 'Multilingual',
            integracao: 'Integration',
            treinamento: 'Training',
            ensino: 'Diversified teaching',
            colecoes: 'Collections'
          },
          content: {
            acesso: {
              p1: '<bold>Access</bold> to BioAtlas is facilitated:',
              b1: '<bold>Simplified:</bold> Use institutional login and password (<bold>SSO - Single Sign-On</bold>) to provide direct access to the platform. Alternatively, explore the <bold>EzProxy or IP address</bold> access options of your university.',
              b2: '<bold>Multiplatform:</bold> Content accessible anywhere and on any device, whether through a <bold>web</bold> browser, or via our native app, available for smartphones and tablets (<bold>Android and iOS</bold>).'
            },
            multilingue: {
              p1: 'BioAtlas was developed with native support for the following languages:',
              b1: 'Portuguese',
              b2: 'Spanish',
              b3: 'English',
              pAfter:
                'This multilingual functionality ensures that the user experience, interface, navigation, and access to documentation are fluid and intuitive for speakers of these three languages, maximizing the potential for use and inclusion of the platform in various geographic and academic contexts.'
            },
            integracao: {
              p1: "<bold>Integrate native</bold> BioAtlas contents (such as 3D models, animations, slides, and radiological exams) <bold>directly into your Educational Institution's educational platform (or LMS)</bold>.",
              p2: 'Ensure the <bold>enhancement of your virtual environment</bold> with simple access to resources and specialized technical support.'
            },
            treinamento: {
              p1: '<bold>Our team of specialists</bold> is fully prepared to offer complete and efficient training to the faculty members of your institution.',
              p2: 'Through <bold>interactive sessions</bold> and continuous support, we ensure that your teachers and instructors acquire the necessary skills and mastery of the tools to <bold>integrate BioAtlas solutions into their work routines</bold> and enhance the teaching-learning process.'
            },
            ensino: {
              p1: 'BioAtlas offers a rich and detailed digital collection, with <bold>thousands of high-fidelity animated 3D contents</bold> for interactive visualization of complex biological structures.',
              p2: 'The platform also provides a collection of high-resolution digitized <bold>histological and histopathological slides</bold>, essential for the study of microanatomy and pathologies.',
              p3: 'Additionally, it includes a robust <bold>diagnostic imaging module</bold> (MRI, CT, US, X-Ray), allowing practice in the interpretation of real exams.'
            },
            colecoes: {
              p1: 'BioAtlas Collections allow the grouping of 3D contents, slides, and radiological images into folders, applying intelligent filters that provide quick, logical, and fluid access.',
              p2: 'They allow <bold>teachers to structure classes</bold> more clearly and <bold>students to perform purposeful reviews</bold>, all integrated on the same platform.',
              p3: 'They represent the link between content, methodology, and engagement.'
            }
          }
        },
        sectionDepoimentos: {
          title: 'See what our users are saying about BioAtlas',
          testimonials: [
            {
              text: 'BioAtlas is an excellent tool for students to integrate the different contents of biological and health sciences.',
              author: 'Dr. Rodolfo Souza de Faria',
              role: 'Professor of Human Physiology and Neurosciences at FMIT'
            },
            {
              text: 'It is very cool to see the parts of human anatomy interactively, didactically, and to have an improved view of each part of the human body very close to reality.',
              author: 'Ana Paula Gomes Peixoto',
              role: 'Afya Faculty of Medical Sciences Contagem'
            },
            {
              text: 'BioAtlas is being fundamental at this moment in my academic journey. Excellent quality material and easy to handle, thus facilitating understanding and learning.',
              author: 'Luciana De Almeida Da Cunha',
              role: 'ULBRA'
            },
            {
              text: 'I would definitely recommend BioAtlas to a friend or colleague because it has content that helps students a lot to study. It helps me in the theoretical and practical classes at the University.',
              author: 'Daniel Vieira de Souza Martins',
              role: 'Unigranrio'
            },
            {
              text: 'BioAtlas is a wonderful medical content platform to strengthen the knowledge and practice of medical students and professionals.',
              author: 'Dra Briseida Estefanía Castillón Betancourt',
              role: 'Surgeon and Obstetrician - IMSS - Mexico'
            },
            {
              text: 'BioAtlas is fundamental for teaching Anatomy and physiological systems, helping a lot in teaching didactics, contributing to the consolidation of knowledge by students.',
              author: 'Dra. Ludmila Alem',
              role: 'Prof. of Anatomy - UFRJ <br />Prof. of SOI - Afya Medicine | Unigranrio'
            }
          ]
        },
        logosCarousel: {
          title:
            'Trusted by leading institutions in more than <span>20</span> countries'
        },
        collectionsPage: {
          banner: {
            title: 'Organize knowledge. Inspire learning.',
            subtitle: 'BioAtlas Collections',
            text: 'BioAtlas Collections allow you to group available Content into didactic sequences, creating visual, connected, and easy-to-share learning experiences.',
            btnText: 'Request a demo'
          },
          explanation: {
            title: 'How Collections work',
            paragraph1:
              'BioAtlas Collections offer intelligent organization for your study material.',
            paragraph2:
              'Easily group 3D content, slides, and radiological images into folders with smart filters, ensuring quick, logical, and intuitive access.',
            paragraph3:
              'On the same platform, teachers can structure lessons with clarity, and students can review content with focus and purpose.',
            paragraph4:
              'BioAtlas Collections are the perfect link between relevant content, effective teaching methodology, and student engagement.',
            btnText: 'Request a demo',
            upperCards: {
              saveChanges: {
                title: 'Save Changes Made to 3D Content',
                text: 'Customize content with text boxes, labels, arrows, and other elements, saving it directly to your collections.'
              },
              shareCollection: {
                title: 'Share your collection with ease',
                text: 'With just one click, you create a link to share your collection with students and teachers.'
              }
            },
            lowerCard: {
              title: 'Smart organization',
              text: 'Group your collections into folders, use content filters, and find exactly what you need — in seconds.'
            }
          },
          visualizer: {
            title:
              'Increase teacher-student interaction and study quality with BioAtlas Collections',
            items: {
              integratedToCurriculum: {
                btnTitle: 'Integrated into the curriculum',
                text: 'Strategically and in detail align each collection of resources and teaching materials to the specific learning objectives and pedagogical methodologies of each curricular subject.'
              },
              teaching: {
                btnTitle: 'Didactic',
                text: 'Learning becomes active and meaningful by encouraging interaction with the collection, constant review of the material, and sharing discoveries with peers.'
              },
              sequential: {
                btnTitle: 'Sequential',
                text: 'BioAtlas Collections organize knowledge in a meaningful way, helping students understand the logical sequence between topics.'
              },
              diversified: {
                btnTitle: 'Diversified',
                text: 'BioAtlas Collections allow you to intelligently group a wide range of digital content, including detailed 3D models, virtual microscopy slides, and radiological images, all in customizable folders.'
              }
            }
          }
        },
        resourcesPage: {
          banner: {
            title: 'Explore the human body in a new way',
            text: 'Study Anatomy, Histological Slides, and Radiological Exams in an integrated, practical, and engaging way through the BioAtlas visualizers.',
            btnText: 'Request a demo'
          },
          visualizer3d: {
            title: '3D Visualizer',
            subtitle: 'Available tools',
            text: 'Visualize anatomical structures in high quality from any angle.',
            items: {
              chapters: {
                btnTitle: 'Chapters',
                text: 'Many of the BioAtlas animations are divided into chapters, which help understand the details of each content piece. Each chapter is designed to cover a specific and fundamental aspect, ensuring that understanding of more complex topics is built step by step, making learning more efficient and accessible.'
              },
              search: {
                btnTitle: 'Search',
                text: 'Dive into structures through the search feature inside the visualizer and explore the presented content in detail. This functionality allows users to locate and isolate specific elements with precision.'
              },
              slice: {
                btnTitle: 'Slice',
                text: 'With the slice tool, you can define precise cutting planes along the three spatial axes — X (width), Y (height), and Z (depth). This enables the virtual dissection of the model or object in question, revealing layers, compositions, and details that would otherwise be hidden in a surface view.'
              },
              annotations: {
                btnTitle: 'Annotations',
                text: 'Make annotations on any content, mark, highlight, or comment directly where the information resides. Add your reflections, questions, or summaries alongside the content.'
              },
              tags: {
                btnTitle: 'Tags',
                text: 'Use tags to mark specific details and retrieve them later efficiently and accurately. This is a powerful tool for organizing and managing information.'
              },
              flashcards: {
                btnTitle: 'Flashcards',
                text: 'Flashcards are resources within chapter-based content, aimed at reinforcing active learning, allowing students to review concepts quickly and interactively.'
              },
              accessibility: {
                btnTitle: 'Accessibility',
                text: 'BioAtlas offers a robust set of meticulously developed accessibility and personalization features to ensure every user can optimize their browsing and study experience. Resources to facilitate access to and understanding of the presented content: change the layout, font size, and much more.'
              },
              animation: {
                btnTitle: 'Animation',
                text: "Interactive and exclusive digital animations, meticulously crafted to be powerful teaching and learning tools. Each piece of content is conceived to transform complex concepts into engaging visual narratives, facilitating users' comprehension and retention of the material."
              }
            }
          },
          visualizerSlides: {
            title: 'Histological Slide Visualizer',
            subtitle: 'Tools',
            text: 'High-resolution digital slides allow you to observe details with clarity, apply zoom, and compare structures, all directly from the browser.',
            items: {
              measure: {
                btnTitle: 'Measure',
                text: 'Perform measurements directly on the digital slide, allowing you to analyze the size and proportion of histological structures with precision. Ideal for morphological studies and comparisons between tissues.'
              },
              progressiveZoom: {
                btnTitle: 'Progressive zoom',
                text: 'Explore the slide at different magnification levels, from the general field to microscopic details. Progressive zoom simulates the optical microscope experience, facilitating gradual understanding of cellular structures. Simulates classic optical microscopy levels, allowing switching between predefined magnifications: 2x 4x 8x 10x 20x 40x.'
              },
              marker: {
                btnTitle: 'Marker',
                text: 'Add custom markings on the slide to highlight regions of interest, support explanations, and record important observations during study or class.'
              },
              panoramic: {
                btnTitle: 'Panoramic',
                text: 'Navigate freely through the high-resolution slide, exploring the entire extent of the tissue with fluidity and control. The panoramic view facilitates spatial contextualization of the analyzed structures.'
              },
              pinsAndArrows: {
                btnTitle: 'Pins and arrows',
                text: 'Use pins and arrows to point out and highlight specific structures on the slide, making the visual explanation clearer and more objective, especially in didactic activities and presentations.'
              },
              infoPanel: {
                btnTitle: 'Info panel',
                text: 'Access detailed information about the slide, such as tissue type, staining, cut type, and histological description, supporting correct interpretation and theoretical learning integrated with the image.'
              }
            }
          },
          visualizerDicom: {
            title: 'Radiology Visualizer',
            subtitle: 'Advanced tools',
            text: 'Learn to interpret imaging exams with clinical context.',
            items: {
              reports: {
                btnTitle: 'Reports',
                text: 'Analyze radiological reports in detail directly in the visualizer, with important information such as exam modality, body region, sex, and findings, for a better understanding of the study.'
              },
              series: {
                btnTitle: 'Image series',
                text: 'Easily navigate between different sequences, planes (axial, coronal, sagittal), or study moments (with and without contrast) for a complete and detailed analysis of anatomy and pathology. Essential for dynamic studies and for a precise three-dimensional view.'
              },
              measurement: {
                btnTitle: 'Measurement',
                text: 'Measure distances, angles, and areas with precision, enabling the quantification of findings (such as the size of nodules or the extent of collections) and the objective tracking of changes over time.'
              },
              contrastControl: {
                btnTitle: 'Brightness and contrast control',
                text: 'Optimize the visualization of different tissues and densities (such as bone, lung parenchyma, or soft tissue structures) by manipulating brightness (level) and contrast (window width). This calibration is crucial for highlighting subtle details and identifying lesions that would otherwise go unnoticed.'
              },
              markersAndAnnotations: {
                btnTitle: 'Annotations and markings',
                text: 'Add arrows, circles, text, and other graphic markings directly on the images to highlight areas of interest, specific measurements, or pathological findings. These annotations are essential for learning and for guiding colleagues during case discussions.'
              },
              multiplePanels: {
                btnTitle: 'Multiple panels',
                text: 'Allows the organization of the workspace to simultaneously display multiple series, slices, or exams side by side. Essential for quickly comparing different modalities (e.g., CT vs. MRI), bilateral assessment (e.g., knees), or for viewing the same finding in different anatomical planes at once, optimizing workflow and information correlation.'
              }
            }
          },
          footer: {
            text: 'Transform the study of medicine into a visual journey. Explore the visualizers and go beyond images: a new way to learn.',
            btnText: 'Request a demo'
          }
        },
        appPage: {
          banner: {
            title: 'BioAtlas App - accessible medical learning anywhere',
            text: 'Study 3D Content, Histology Slides, and Radiology Exams using your Tablet or Smartphone, organize your content, create collections, and keep learning always within reach.'
          },
          visualizer: {
            title: 'Features and highlights of the BioAtlas App',
            items: {
              onlineOffline: {
                btnTitle: 'Online and offline access',
                text: 'Access BioAtlas content at any time, even offline. Download the content and continue your learning journey without interruptions.'
              },
              unifiedCollections: {
                btnTitle: 'Unified collections',
                text: 'Collections created on the web can be accessed in the BioAtlas app and vice versa.'
              },
              contentDiversity: {
                btnTitle: 'Content diversity',
                text: 'Explore a vast library of content that the BioAtlas App offers in the palm of your hand. A true medical learning hub, bringing together an unparalleled diversity of content, accessible anytime, anywhere.'
              },
              flashcards: {
                btnTitle: 'Flashcards',
                text: 'Review essential concepts, test your memory, and learn more efficiently using BioAtlas Flashcards. (coming soon)'
              },
              responsive: {
                btnTitle: 'Responsive',
                text: 'Navigation on Tablets offers an experience similar to a desktop. On smartphones, all content has been optimized, ensuring quick and practical access in the palm of your hand.'
              }
            }
          }
        },
        contentCreationProcessPage: {
          banner: {
            title: 'How our Platform Content is produced',
            subtitle: 'BioAtlas Creation Process',
            text: 'Our content development process combines medical expertise, cutting-edge technology, and rigorous content quality control to deliver the best learning experience in anatomy and medical sciences.'
          },
          process: {
            title: 'Creation process',
            text: 'Content development at BioAtlas follows a structured flow that integrates {highlight} Based on educational demands, usage data, and strategic guidelines, the objectives of each piece of content, its scope, and the resources needed for its production are defined.',
            textHighlight:
              'scientific research, pedagogical planning, production and preparation of educational materials, and technical validation.'
          },
          curation: {
            modeling3D: {
              title: '3D Model Development',
              introText:
                'The production of three-dimensional models and animations is carried out progressively, from the morphological definition of structures to their technical and visual refinement. Development is always guided by scientific accuracy and clarity of representation. This level of precision is ensured by technical and scientific reviews, which guarantee that the models are aligned with the references used and with the defined educational objectives.',
              closingText:
                'Each of these stages undergoes a double review: a technical one carried out by the 3D Coordination team and a conceptual one carried out by the Content team. The next stage only begins once the previous one has been doubly approved by both teams. This ensures the technical-scientific quality of all the content we produce.',
              steps: {
                morphology: {
                  label: 'Morphology',
                  caption:
                    'The most detailed and "heaviest" model. This stage ensures the correct morphology of the content'
                },
                texturing: {
                  label: 'Texturing',
                  caption:
                    'A painting stage to assign colors, shine, shading, and fine details to the model'
                },
                animation: {
                  label: 'Animation',
                  caption:
                    'Animated content needs a digital skeleton so that movements can be created'
                },
                drilling: {
                  label: 'Perforation check',
                  caption:
                    'At Atlas, we must ensure that objects are not perforating any of the existing structures'
                },
                implementation: {
                  label: 'Implementation',
                  caption:
                    'The content is implemented in the "engine" and, once fully approved, is included in BioAtlas'
                }
              }
            },
            histology: {
              title: 'Curation of Histology and Histopathology Slides',
              introText:
                'The curation of histological and histopathological slides follows a rigorous process that combines clinical relevance, image quality, and scientific accuracy, from selection through to content publication.',
              closingText:
                'As with the other areas, each stage undergoes a double technical and conceptual review before moving on to the next, ensuring consistency and quality throughout the entire collection.',
              steps: {
                evaluation: {
                  label: 'Technical evaluation',
                  caption:
                    'Careful analysis of the selected slides, ensuring clinical relevance and image quality'
                },
                production: {
                  label: 'Content production and validation',
                  caption:
                    'Preparation of descriptive texts and scientific validation with the content team'
                },
                enrichment: {
                  label: 'Educational enrichment',
                  caption:
                    'Inclusion of flashcards, nomenclature, and supplementary materials to deepen learning'
                }
              }
            },
            radiology: {
              title:
                'Curation of Imaging Exams (Radiology, Diagnostic Imaging, and others)',
              introText:
                'Imaging exams go through a curation process that prioritizes diagnostic quality and educational relevance, ensuring that every published material adds value to learning.',
              closingText:
                'All stages include a double technical and conceptual review, ensuring the standardization and scientific reliability of all published content.',
              steps: {
                technicalEvaluation: {
                  label: 'Technical evaluation',
                  caption:
                    'Selection and technical analysis of imaging exams, prioritizing diagnostic quality and educational relevance'
                },
                validation: {
                  label: 'Information validation',
                  caption:
                    'Review of the clinical information and reports associated with each exam'
                },
                organization: {
                  label: 'Organization and standardization',
                  caption:
                    'Cataloging of exams following platform standards to facilitate navigation'
                }
              }
            }
          },
          terminology: {
            title: 'Terminology',
            text: 'Defining terminology and corresponding nomenclature, alongside the development of descriptive texts and interactive flashcards, guides the user experience, fostering a deeper understanding of the content.'
          },
          howItsDone: {
            title: 'How it is done',
            text: 'The entire process is documented, and scientific information is carefully catalogued. As a reference, we use well-established medical literature, aligned with medical and related field training curricula'
          },
          contentTeam: {
            title: 'Content Team',
            text1:
              "The content team is a Medical Harbour division responsible for curating, validating, and standardizing all scientific information incorporated into the platform. It is composed of healthcare professionals and biologists with solid academic backgrounds, including stricto sensu graduate degrees (master's and doctorate).",
            text2:
              'We also rely on the collaboration of external specialists, who are called upon as needed to support content validation in highly specific areas. These professionals contribute technical analysis and specialized corrections, ensuring greater depth and scientific accuracy in the materials developed.'
          },
          team3D: {
            title: '3D Team',
            text1:
              "Medical Harbour's 3D team is composed of skilled artists with different levels of seniority, fully familiar with the production of assets related to human anatomy, biological processes, and the healthcare field. The team's main responsibility is producing and implementing all of BioAtlas's 3D content, as well as developing images of these models used both on the viewer page and for marketing.",
            text2:
              'The content development process consists of several stages, and each artist is closely monitored, with constant feedback provided by direct leadership so that the models produced have the best possible artistic and technical quality.'
          }
        },
        integrationPage: {
          banner: {
            title: 'Institutional Integration',
            subtitle: 'For institutions and partners',
            text: 'Transform your educational platform with BioAtlas content, simple and fast access and dedicated technical support.',
            btnText: 'Request a demo'
          },
          content: {
            title: 'Content integration',
            text: 'Connect BioAtlas to the learning management system already used at your Institution (e.g., Moodle, Canvas) so that content is delivered directly to the relevant courses.',
            imgAlt: 'Content integration'
          },
          access: {
            title: 'Unified access',
            paragraph1:
              'BioAtlas provides resources to facilitate access through your teaching platform, making it easier for teachers and students to engage with the tool.',
            paragraph2:
              "Students and teachers can access BioAtlas through their institution's portal without needing a login and password, via SSO/EZ Proxy integrations.",
            whyTitle: "Why it's useful:",
            whyText:
              'Eliminates the need for extra passwords, reduces support requests, and makes usage more natural (a {highlight} login for everything).',
            whyTextHighlight: 'single',
            btnText: 'Talk to the sales team'
          },
          api: {
            title: 'BioAtlas 3D content in your project via our API',
            text: 'Build a 3D virtual interactive experience in your project related to anatomy or other disciplines related to the basic cycle in Health. BioAtlas content can be easily integrated into your website, digital content, LMS or digital project through the BioAtlas API.'
          },
          institutions: {
            title: 'BioAtlas for your institution',
            items: {
              pharma: 'Pharmaceutical',
              university: 'Universities',
              hospital: 'Hospitals',
              publisher: 'Publishers'
            }
          },
          whiteLabel: {
            title: "BioAtlas with your Institution's brand",
            text: 'BioAtlas has a "Private Label" solution, which allows you to brand your Institution, making it a 100% customized solution.'
          },
          embed: {
            title: 'Content embedding',
            text: "Embed BioAtlas content (3D models, animations, slides, radiology images) within your Institution's website, CMS or digital environment. Our detailed technical documentation and dedicated support are ready to assist your IT team throughout the entire implementation process, ensuring a quick and successful integration. Transform the way your institution delivers knowledge.",
            whyTitle: 'Why is it useful?',
            whyText:
              'Students do not need to leave the university portal to access the material, making the experience more fluid and professional.'
          },
          footer: {
            text: "BioAtlas was created to value students' time and effort, making learning more accessible and practical.",
            btnText: 'Request a demo'
          }
        },
        forTeachers: {
          hero: {
            title: 'Resources designed for teachers.',
            text: "BioAtlas acts as a teaching partner, enhancing the teacher's work. The platform modernizes the classroom experience and places the educator at the center of academic innovation.",
            button: 'Request presentation'
          },
          auxiliar: {
            title: 'BioAtlas: Your Essential Teaching Assistant',
            tabs: {
              aulasAtrativas: 'More engaging <br/> classes',
              ferramentas: 'Presentation <br/> tools',
              colecoes: 'Custom <br/> Collections',
              sugestoes: 'Content <br/> suggestions'
            },
            imageAlts: {
              aulasAtrativas: 'More engaging classes',
              ferramentas: 'Presentation tools',
              colecoes: 'Custom Collections',
              sugestoes: 'Content suggestions'
            },
            content: {
              aulasAtrativas: {
                p1: "Optimize lesson preparation and maximize student engagement with BioAtlas' interactive collection of thousands of high-fidelity contents and presentation tools."
              },
              ferramentas: {
                p1: 'Enhance your classes with integrated tools that allow immediate manipulation and customization of content:',
                b1: '<bold>Interactivity</bold>: Use cutting and element selection functions in 3D, Slide, and Radiology viewers.',
                b2: '<bold>Focus and Collaboration</bold>: Insert annotations and comments directly on structures and images to optimize communication and guide participants.'
              },
              colecoes: {
                p1: 'With BioAtlas, teachers have the freedom to modify 3D content to suit their classes. They can also save these changes in personal collections and easily share them with all students.'
              },
              sugestoes: {
                p1: "Teacher collaboration is essential to enhance BioAtlas' teaching catalog. Educators can suggest new content or flag missing materials to enrich and complement their classes."
              }
            }
          },
          depoimentos: {
            title: 'See what some of our users have to say about BioAtlas:',
            testimonials: [
              {
                text: '\u201cBioAtlas is an excellent tool for students to integrate the different contents of biological and health sciences\u201d',
                author: 'Dr. Rodolfo Souza de Faria',
                role: 'Professor of Human Physiology and Neurosciences at FMIT'
              },
              {
                text: '\u201cBioAtlas is a wonderful medical content platform to strengthen the knowledge and practice of medical students and professionals.\u201d',
                author:
                  'Dra. Briseida Estefan\u00eda Castill\u00f3n Betancourt',
                role: 'Surgeon and Obstetrician - IMSS - Mexico'
              },
              {
                text: '\u201cBioAtlas is essential for teaching Anatomy and physiological systems, greatly supporting teaching didactics and contributing to the consolidation of knowledge by students.\u201d',
                author: 'Dra. Ludmila Alem',
                role: 'Prof. of Anatomy - UFRJ <br /> Prof. of SOI - Afya Medicine | Unigranrio'
              }
            ]
          },
          cta: {
            text: 'BioAtlas offers a more practical and accessible learning experience.',
            button: 'Request presentation'
          }
        },
        forStudents: {
          hero: {
            title: 'Dynamic study for a restless generation',
            text: "Transform theory into practice, simplify learning, and retain students' attention with BioAtlas. Put the student in charge of their own medical trajectory.",
            button: 'Request presentation'
          },
          auxiliar: {
            title: "How BioAtlas supports Students' Academic Routine",
            tabs: {
              conexaoProfessores: 'Connection with <br/> Teachers',
              aprendizadoPratico: 'Practical <br/> Learning',
              disponivelBolso: 'Available in <br/> your pocket',
              estudoDinamico: 'Dynamic <br/> study'
            },
            imageAlts: {
              conexaoProfessores: 'Connection with Teachers',
              aprendizadoPratico: 'Practical Learning',
              disponivelBolso: 'Available in your pocket',
              estudoDinamico: 'Dynamic study'
            },
            content: {
              conexaoProfessores: {
                p1: 'Students have the freedom to access collections shared by teachers, review the same content covered in class, and study clearly, at their own pace.'
              },
              aprendizadoPratico: {
                p1: 'Explore realistic 3D models, digital histological slides, and integrated radiology, understanding the human body in detail and connections.'
              },
              disponivelBolso: {
                p1: 'BioAtlas offers flexible access across multiple devices, ensuring students can consult their course materials at any time, even outside the academic environment.'
              },
              estudoDinamico: {
                p1: 'With custom collections and smart filters, students can select the content they want to review and organize their favorite study topics.'
              }
            }
          },
          depoimentos: {
            title: 'What some of our users say about BioAtlas:',
            testimonials: [
              {
                text: '“I would definitely recommend BioAtlas to a friend or colleague because it has content that helps students a lot to study. It helps me in my theoretical and practical classes at the University.”',
                author: 'Daniel Martins Vieira',
                role: 'Student at Unigranrio'
              },
              {
                text: '“Very cool to see the parts of human anatomy in an interactive, educational way, and to have an improved view of each part of the human body very close to reality.”',
                author: 'Ana Paula Gomes Peixoto',
                role: 'Afya Faculty of Medical Sciences Contagem'
              },
              {
                text: '“BioAtlas is being fundamental at this moment of my academic career. Material of excellent quality and easy to use, thus facilitating understanding and learning.”',
                author: 'Luciana de Almeida da Cunha',
                role: 'Medical Student <br /> ULBRA'
              }
            ]
          },
          cta: {
            text: 'BioAtlas was created to value the time and effort of medical students.<br/>Here, knowledge takes shape, content connects, and learning becomes more accessible and practical.',
            button: 'Request presentation'
          },
          aprendaInteligente: {
            title: 'Learn smartly, anytime and anywhere',
            description:
              'BioAtlas is your ideal companion for the human health study routine. Made to accompany you in college, at home, or during reviews, it allows you to find the necessary content in just a few clicks. Review for exams and stay focused on what really matters: learning with clarity.',
            cards: {
              colecoes: {
                title: 'Collections, Notes, and Custom Bookmarks',
                description:
                  'Create a fully customized learning environment. Use notes and bookmarks to record observations, highlight key points, and make it easier to review essential content.'
              },
              flashcards: {
                title: 'Review with flashcards',
                description:
                  'With BioAtlas flashcards, you review concepts, test your knowledge, and consolidate content in an agile and fun way.<br/><br/>Ideal for preparing before exams and improving long-term memory.'
              },
              modelos: {
                title:
                  'Interactive 3D Models, Radiological Exams, and Study Slides',
                description:
                  'Explore the human body in an integrated and visual way. In BioAtlas, you can rotate, zoom in, and compare anatomical models, observe digital histological slides, and correlate them with real radiological images.'
              }
            }
          }
        },
        facilitySection: {
          sectionTitle: 'Ease of use from day one',
          features: {
            treinamento: {
              cardTitle: 'Simplified\nTraining',
              title: 'Simplified Training',
              description:
                'Master all BioAtlas features, from first access to advanced analysis, visualization, and management. Optimize your workflow and maximize platform usage.',
              imageAlt: 'People in training with presentation screen'
            },
            multiplataforma: {
              cardTitle: 'Multiplatform\nAccess',
              title: 'Multiplatform Access',
              description:
                'BioAtlas is available for access on any web browser, in addition to dedicated applications for mobile devices (phones and tablets) on Android and iOS platforms.',
              imageAlt: 'Devices displaying the Bioatlas platform'
            },
            integracao: {
              cardTitle: 'Integration with\nExternal Platforms',
              title: 'Integration with External Platforms',
              description:
                'Our content can be embedded into the website of the Educational Institution you work for through our API.',
              imageAlt: 'Monitor displaying integration with external platforms'
            },
            acervo: {
              cardTitle: 'Collection of Thousands\nof Contents',
              title: 'Collection of thousands of contents',
              description:
                'BioAtlas is an essential tool for pedagogical excellence, providing a vast interactive collection with thousands of high-fidelity contents:',
              item1: '3D Structure Models',
              item2: 'Detailed Histological and Histopathological Slides',
              item3: 'Diagnostic Imaging Materials',
              imageAlt: 'Interface of the 3D content collection'
            }
          }
        },
        completeAnatomy: {
          hero: {
            title: 'Explore the Human Body in Detail',
            text: 'Contents that facilitate learning of human health disciplines through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request presentation'
          },
          sidebar: {
            title: 'Learn more about the teaching modules',
            button: 'Request presentation'
          },
          main: {
            title: 'Complete Anatomy',
            paragraph:
              'Human Anatomy is the science that studies the morphology and organization of the human body through the observation and analysis of its constituent macroscopic structures. This analysis is correlated with the functioning of the various body parts and the mechanisms of development and response to environmental, genetic, and temporal factors. It can be categorized, based on the division of its structures, into Organ Systems and Anatomical Regions. This module includes representative anatomical models of both the male and female human body.',
            atlas3D: {
              title: '3D Anatomical Atlas',
              paragraph:
                'This module features more than 2,500 identified structures, according to the International Anatomical Terminology. It is separated into Male and Female models and organized according to 12 anatomical systems and 9 regions.'
            },
            atlasHumano: {
              title: 'Human Atlas',
              paragraph:
                'The Human Atlas consists of a 3D model composed of all anatomical systems of the human body, labeled and with an advanced organizational system. Developed with the highest texture quality, the atlas ensures an impressive set of data that can be used as a reference during the discussion of a case, a surgical plan, or an anatomy class. It is separated into female and male models, and also includes content focused on the study of the imaginary planes that divide the human body. They are:',
              list: {
                female: 'Female: 2501 objects.',
                male: 'Male: 2518 objects.',
                planes: 'Anatomical Planes: separated into two scenes, namely:',
                delimitation: 'Planes of delimitation: 7 objects.',
                section: 'Planes of section: 5 objects.'
              }
            },
            cadaver3D: {
              title: '3D Virtual Cadaver',
              paragraph:
                'A 3D version of a real human body divided into 1,878 slices and photographed with extremely high-resolution equipment, digitally reconstructed in 3D. The Virtual Cadaver has its colors preserved and is segmented and mapped for a complete visualization.'
            }
          },
          updates: {
            title: 'Discover our Anatomy content updates',
            olhoHumano: 'Anatomy - Human Eye',
            cranio: 'Anatomy - Descriptive Elements of the Skull',
            esqueletoAxial:
              'Anatomy - Descriptive Elements of the Axial Skeleton'
          }
        },
        topographicAnatomy: {
          hero: {
            title: 'Explore the Human Body in Detail',
            text: 'Content that facilitates the learning of human health disciplines through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request presentation'
          },
          sidebar: {
            title: 'Learn more about the teaching modules',
            button: 'Request presentation'
          },
          main: {
            title: 'Topographic Anatomy',
            paragraph:
              'Topographic Anatomy deals with the study of the division of the human body into regions, in order to facilitate the understanding of anatomical relationships between structures of all systems in a given segment of the body. This method helps master the general topography of organs from the perception of functioning and location of all nearby and related parts.',
            anatomicalParts: {
              title: 'Anatomical Parts',
              left: {
                dentalAnatomy: 'Dental Anatomy',
                longBones: 'Internal Anatomy of Long Bones',
                dentalArch: 'Dental Arch',
                cerebralCortex: 'Functional Areas of the Cerebral Cortex',
                heartLayers: 'Layers of the Heart',
                coronaryCirculation: 'Coronary Circulation',
                skullElements: 'Descriptive Elements of the Skull',
                appendicularSkeleton:
                  'Descriptive Elements of the Appendicular Skeleton'
              },
              right: {
                axialSkeleton: 'Descriptive Elements of the Axial Skeleton',
                completeBrain: 'Complete Brain',
                brainStructures: 'Brain Structures',
                heartFaces: 'Faces and Margins of the Heart',
                greatVessels: 'Great Vessels of the Heart',
                humanEye: 'Human Eye in Detail',
                orbitSection: 'Human Eye - Section Through the Orbit',
                languageProcessing: 'Language Processing'
              }
            },
            topographicRegions: {
              title: 'Topographic Regions',
              left: {
                abdomen: 'Abdomen',
                headAndNeck: 'Head and Neck',
                back: 'Back',
                rightLowerLimb: 'Right Lower Limb',
                leftLowerLimb: 'Left Lower Limb',
                rightUpperLimb: 'Right Upper Limb',
                leftUpperLimb: 'Left Upper Limb',
                pelvis: 'Pelvis',
                thorax: 'Thorax'
              },
              right: {
                axialSkeleton: 'Descriptive Elements of the Axial Skeleton',
                completeBrain: 'Complete Brain',
                brainStructures: 'Brain Structures',
                heartFaces: 'Faces and Margins of the Heart',
                greatVessels: 'Great Vessels of the Heart',
                humanEye: 'Human Eye in Detail',
                orbitSection: 'Human Eye - Section Through the Orbit',
                languageProcessing: 'Language Processing'
              }
            }
          },
          updates: {
            title: 'Discover our Anatomy content updates',
            ossosLongos: 'Anatomy - Internal Anatomy of Long Bones',
            rinsBexiga: 'NEW - Improvements in kidney and bladder models',
            pulmao: 'NEW - Improvements in the lung model'
          }
        },
        systemicAnatomy: {
          hero: {
            title: 'Explore the Human Body in Detail',
            text: 'Content that facilitates the learning of human health disciplines through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request presentation'
          },
          sidebar: {
            title: 'Learn more about the teaching modules',
            button: 'Request presentation'
          },
          main: {
            title: 'Systemic Anatomy',
            paragraph:
              'Systemic Anatomy deals with the study of the organ systems of the human body, establishing sets of organs and anatomical parts that perform, in an integrated way, the same functions in biological mechanisms. Although each system performs a distinct task, they are all interconnected, ensuring the functioning and survival of the organism as a whole. In this module, the following systems are considered:',
            list: {
              arterial: 'Arterial',
              articular: 'Articular',
              boneClassification: 'Bone Classification',
              digestorio: 'Digestive',
              skeletonElements: 'Descriptive Elements of the Skeleton',
              endocrino: 'Endocrine',
              esqueletico: 'Skeletal',
              linfatico: 'Lymphatic',
              muscular: 'Muscular',
              nervoso: 'Nervous',
              respiratorio: 'Respiratory',
              tegumentar: 'Integumentary',
              urogenital: 'Urogenital',
              venoso: 'Venous'
            }
          },
          updates: {
            title: 'Discover our Anatomy content updates',
            digestorio: 'NEW - Update of the Female Digestive System',
            rinsBexiga: 'NEW - Improvements in kidney and bladder models',
            pulmao: 'NEW - Improvements in the lung model'
          }
        },
        cytology: {
          hero: {
            title: 'Explore the Human Body in Detail',
            text: 'Content that facilitates the learning of human health disciplines through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request presentation'
          },
          sidebar: {
            title: 'Learn more about the teaching modules',
            button: 'Request presentation'
          },
          main: {
            title: 'Cytology',
            paragraph:
              'The Cytology module allows users to explore cellular structures in detail, interacting end-to-end with two categories of 3D content: Cells and Cell Membrane. Navigate through the cells:',
            cells: {
              title: 'Cells',
              left: {
                adiposeCell: 'Adipose Cell',
                animalCell: 'Complete Animal Cell',
                bacterialCell: 'Bacterial Cell',
                immuneSystemCells: 'Immune System Cells',
                bloodCells: 'Blood Cells',
                muscleFiber: 'Muscle Fiber'
              },
              right: {
                thyroidFollicle: 'Thyroid Follicle',
                langerhansIslets: 'Islets of Langerhans - Endocrine Pancreas',
                neuron: 'Neuron',
                aboSystem: 'ABO System',
                virus: 'Virus'
              }
            },
            cellMembrane: {
              title: 'Cell Membrane',
              list: {
                membrane: 'Cell Membrane',
                primaryActive:
                  'Primary Active Transport - Sodium and Potassium Pump',
                secondaryActiveCountertransport:
                  'Secondary Active Transport - Countertransport',
                secondaryActiveCotransport:
                  'Secondary Active Transport - Cotransport',
                facilitatedDiffusion:
                  'Passive Transport - Facilitated Diffusion',
                simpleDiffusion: 'Passive Transport - Simple Diffusion'
              }
            }
          },
          updates: {
            title: 'Discover our Cytology content updates',
            celulaNervosa: 'Cytology - Nerve Cell',
            celulasSanguineas: 'Cytology - Blood Cells',
            sistemaImunologico: 'Cytology - Cells of the Immune System'
          }
        },
        biochemistry: {
          hero: {
            title: 'Explore the Human Body in Detail',
            text: 'Content that facilitates the learning of human health disciplines through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request presentation'
          },
          sidebar: {
            title: 'Learn more about the teaching modules',
            button: 'Request presentation'
          },
          main: {
            title: 'Biochemistry',
            paragraph:
              'Biochemistry studies molecular processes in living organisms, being essential for understanding health and the origin of diseases. By studying biomolecules — such as proteins, lipids, carbohydrates, and nucleic acids — and the complex metabolic pathways that regulate cellular function, it allows one to interpret the organism at its most fundamental level. This knowledge is decisive not only for understanding the basis of physiological and pathological processes, but also for the development of therapies, diagnostics, and technologies applied to health. Thus, Biochemistry expands the capacity for scientific investigation and promotes an integrated view of the body.',
            bullet1: 'Enzyme Action',
            bullet2: 'Amino Acid Catabolism',
            bullet3: 'Urea Cycle',
            bullet4: 'Citric Acid Cycle',
            bullet5: 'Amino Acid Structure',
            bullet6: 'Secondary Protein Structure',
            bullet7: 'Tertiary and Quaternary Protein Structures',
            bullet8: 'Oxidative Phosphorylation',
            bullet9: 'Glycogenesis',
            bullet10: 'Glycolysis',
            bullet11: 'Gluconeogenesis',
            bullet12: 'Fatty Acid Oxidation',
            bullet13: 'Free Radicals',
            bullet14: 'Cell Membrane Signaling',
            bullet15: 'Carbohydrate Types',
            bullet16: 'Pentose Phosphate Pathway'
          },
          updates: {
            title: 'Discover our Biochemistry content updates',
            celulaNervosa: 'Biochemistry - Nerve Cell',
            celulasSanguineas: 'Biochemistry - Blood Cells',
            sistemaImunologico: 'Biochemistry - Immune System Cells'
          }
        },
        cadaverVirtual: {
          hero: {
            title: 'Explore the Human Body in Detail',
            subtitle:
              'Content that facilitates the learning of human health disciplines through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request presentation'
          },
          sidebar: {
            title: 'Learn more about the teaching modules',
            button: 'Request presentation'
          },
          main: {
            title: 'Virtual Cadaver',
            paragraph:
              'The Virtual Cadaver module delivers an immersive anatomy learning experience using digitized real specimens. With intuitive navigation, multi-plane visualization, and in-depth study resources, students build spatial understanding and clinical reasoning in an active and safe way.',
            list: {
              item1: 'Anatomical visualization by systems and regions',
              item2: 'Exploration through slices in different planes',
              item3: 'Digitized real specimens with high fidelity',
              item4: 'Detailed identification of structures',
              item5: 'Smooth navigation for guided or free study',
              item6: 'Supports clinical reasoning development',
              item7: 'Ideal content for review and retention',
              item8: 'Integration with basic and clinical disciplines',
              item9: 'Interactive experience in a digital environment',
              item10: 'More autonomy in the learning process',
              item11: 'Facilitates form-and-function correlation',
              item12: 'Progressive deepening by complexity level',
              item13: 'Support for in-person and hybrid teaching',
              item14: 'Modern resource for health education'
            }
          }
        },
        embryology: {
          hero: {
            title: 'Explore the Human Body in Detail',
            text: 'Content that facilitates the learning of human health disciplines through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request presentation'
          },
          sidebar: {
            title: 'Learn more about the teaching modules',
            button: 'Request presentation'
          },
          main: {
            title: 'Embryology',
            paragraph:
              'Ensuring an interactive view of human development, follow embryonic and fetal development from oogenesis/spermatogenesis to the final stage of intrauterine development through interactive 3D animations of the Embryonic Period of Development and the Fetal Period of Development.',
            lists: {
              left: {
                cleavage: 'Cleavage',
                spermatogenesis: 'Spermatogenesis',
                fertilization: 'Fertilization',
                blastocystFormation: 'Blastocyst Formation',
                twinPregnancy: 'Twin Pregnancy',
                pregnancy: 'Pregnancy'
              },
              right: {
                implantation: 'Implantation',
                oogenesis: 'Oogenesis',
                embryonicPeriodDevelopment: 'Embryonic Period of Development',
                fetalPeriodDevelopment: 'Fetal Period of Development',
                placentaInDetail: 'Placenta in Detail',
                fetalAnatomicalPlanes: 'Fetal Anatomical Planes'
              }
            }
          },
          updates: {
            title: 'Discover our Embryology content updates',
            placentaDetalhes: 'Embryology - Placenta in Detail',
            gestaoGemelar: 'Embryology - Twin Pregnancy',
            visaoGeral: 'Embryology - Overview'
          }
        },
        physiology: {
          hero: {
            title: 'Explore the Human Body in detail',
            text: 'Content that facilitates learning through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request presentation'
          },
          sidebar: {
            title: 'Learn more about teaching models',
            button: 'Request presentation'
          },
          main: {
            title: 'Physiology',
            paragraph:
              'Explore the functioning and normal functions of the human body through interactive 3D virtual content',
            homeostasis: {
              title: 'Homeostasis and Control',
              left: {
                1: 'Insulin Action in the Muscle Cell',
                2: 'Insulin Action in the Adipocyte',
                3: 'Insulin Action in the Hepatocyte',
                4: 'Glucagon Action in the Muscle Cell',
                5: 'Glucagon Action in the Hepatocyte',
                6: 'Hyperglycemia Control - Insulin'
              },
              right: {
                1: 'Hypoglycemia Control - Glucagon',
                2: 'Functions of Thyroid Hormones',
                3: 'Insulin Secretion in the Pancreas',
                4: 'Glucagon Secretion in the Pancreas',
                5: 'Synthesis and Secretion of Thyroid Hormones'
              }
            },
            functionalProcesses: {
              title: 'Functional Processes',
              left: {
                1: 'Antibodies: Classes and Functions',
                2: 'Coagulation Cascade',
                3: 'Cardiac Cycle of the Human Heart',
                4: 'Pulmonary and Systemic Circulation',
                5: 'Muscle Fiber Contraction',
                6: 'Renal Functions'
              },
              right: {
                1: 'Generation and Conduction of Action Potential',
                2: 'Pulmonary Hematosis',
                3: 'Feedback Mechanism',
                4: 'Synaptic Transmission',
                5: 'Pulmonary Ventilation'
              }
            }
          },
          updates: {
            title: 'Discover our Physiology updates',
            hematosePulmonar: 'Physiology - Pulmonary Hematosis',
            controleHiperglicemiaInsulina:
              'Physiology - Insulin Hyperglycemia Control',
            transmissaoSinaptica: 'Physiology - Synaptic Transmission'
          }
        },
        histology: {
          hero: {
            title: 'Explore the Human Body in detail',
            text: 'Content that facilitates the learning of human health disciplines through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request presentation'
          },
          sidebar: {
            title: 'Learn more about the analysis modules',
            button: 'Request presentation'
          },
          main: {
            title: 'Histology',
            paragraph:
              'BioAtlas has a module dedicated to the study of slides with hundreds of examples of glands, organs, tissues, and systems, and slides with pathologies. In addition, it has a tool with resources for their visualization and analysis with zoom up to 40x, marking on slides, mirroring, etc.',
            bullet1: 'Sensory Organs (Integumentary and Nervous)',
            bullet2:
              'Tissues (Cartilaginous, Connective, Epithelial, Muscular, and Osseous)',
            bullet3:
              'Systems (Circulatory, Digestive, Endocrine, Skeletal, Lymphatic, Nervous, Respiratory, Integumentary, and Urogenital)'
          },
          updates: {
            title: 'Discover our Histology updates',
            novasLaminasDescritivos:
              'NEW - Descriptive texts on all histological slides',
            patologiaHistopatologia: 'Pathology - Histopathology',
            histopatologiaNovasLaminas: 'HISTOPATHOLOGY - New Slides'
          }
        },
        histopathology: {
          hero: {
            title: 'Explore the Human Body in detail',
            text: 'Content that facilitates the learning of human health disciplines through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request presentation'
          },
          sidebar: {
            title: 'Learn more about the teaching modules',
            button: 'Request presentation'
          },
          main: {
            title: 'Histopathology',
            paragraph:
              'This category contains histological slides that highlight pathologies in tissues and cells from various systems and anatomical regions of the human body.',
            bullet1: 'Blood Circulation Disorders',
            bullet2: 'Cardiovascular System Diseases',
            bullet3: 'Digestive System Diseases',
            bullet4: 'Endocrine System Diseases',
            bullet5: 'Genital System Diseases',
            bullet6: 'Hematopoietic System Diseases',
            bullet7: 'Nervous System Diseases',
            bullet8: 'Respiratory System Diseases',
            bullet9: 'Urogenital System Diseases',
            bullet10: 'Muscular and Skeletal System Diseases',
            bullet11: 'Immunological Diseases',
            bullet12: 'Inflammation',
            bullet13: 'Cell and Tissue Injury and Repair',
            bullet14: 'Tumor'
          },
          updates: {
            title: 'Discover our Histopathology updates',
            novidadeModuloHistopatologia: 'NEW - Histopathology Module',
            novosTextosTumor: 'New descriptive texts Histopathology Tumor',
            histopatologiaNovasLaminas: 'HISTOPATHOLOGY - New Slides'
          }
        },
        pathology: {
          hero: {
            title: 'Explore the Human Body in detail',
            text: 'Content that facilitates the learning of human health disciplines through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request demonstration'
          },
          sidebar: {
            title: 'Learn more about the teaching modules',
            button: 'Request presentation'
          },
          main: {
            title: 'Pathology',
            paragraph:
              'Pathology is the science responsible for studying diseases that can affect an individual, analyzing structural and functional changes in cells, tissues, and organs, as well as associated clinical manifestations. Among its objects of study, General Pathology stands out as one of its pillars. This area investigates the basic principles of disease, such as inflammation, necrosis, circulatory disorders, changes in cell growth, among other pathological processes common to different illnesses. By integrating knowledge from basic sciences and applying it to clinical practice, Pathology serves as a scientific foundation for the training of health professionals.',
            section1Title: 'Pathological Conditions',
            section2Title: 'General Pathology',
            bullet1_1: 'Acne',
            bullet1_2: 'Pleural Conditions',
            bullet1_3: 'Sickle Cell Anemia',
            bullet1_4: 'Asthma',
            bullet1_5: 'Ischemic Heart Disease',
            bullet1_6: 'Skin Cancer',
            bullet1_7: 'Spinal Deformities',
            bullet1_8: 'Diabetes Mellitus Type 1',
            bullet1_9: 'Diabetes Mellitus Type 2',
            bullet1_10: 'Muscle Strain',
            bullet1_11: "Graves' Disease",
            bullet1_12: 'Polycystic Kidney Disease',
            bullet1_13: 'Peptic Ulcer Disease',
            bullet1_14: 'Bone Fractures',
            bullet1_15: 'Gastritis',
            bullet1_16: 'Kidney Stones',
            bullet1_17: 'Pneumonia',
            bullet1_18: 'Sinusitis',
            bullet1_19: 'Polycystic Ovary Syndrome',
            bullet1_20: "Hashimoto's Thyroiditis",
            bullet1_21: 'Thrombosis',
            bullet1_22: 'Pulmonary Embolism',
            bullet1_23: 'Tuberculosis',
            bullet1_24: 'Urticaria',
            bullet2_1: 'Cellular Adaptations - Hyperplasia and Metaplasia',
            bullet2_2: 'Cellular Adaptations - Hypertrophy and Atrophy',
            bullet2_3: 'Pathological Calcification',
            bullet2_4: 'Hemodynamic Disorders - Hemorrhage',
            bullet2_5: 'Cellular Aging',
            bullet2_6: 'Oxidative Stress',
            bullet2_7: 'Acute Inflammation',
            bullet2_8: 'Chronic Inflammation',
            bullet2_9: 'Cell Death by Apoptosis',
            bullet2_10: 'Cell Death by Necrosis',
            bullet2_11: 'Morphological Patterns of Necrosis',
            bullet2_12: 'Tissue Repair'
          },
          updates: {
            title: 'Discover our Pathology updates',
            update1: 'Pathology - Pulmonary Embolism',
            update2: 'Pathology - Acne',
            update3: 'Pathology - Gastritis'
          }
        },
        radiology: {
          hero: {
            title: 'Explore the Human Body in detail',
            text: 'Content that facilitates the learning of human health disciplines through interactivity. Integrates the areas of Morphological Sciences, Physiological Sciences, Human Sciences, and Social Sciences Applied to Health.',
            button: 'Request presentation'
          },
          sidebar: {
            title: 'Learn more about the teaching modules',
            button: 'Request presentation'
          },
          main: {
            title: 'Radiology',
            paragraph:
              'System for viewing DICOM images with tools for handling radiological studies and clinical cases. It allows visualization of images from different modalities such as:',
            bullet1: 'Computed tomography scans;',
            bullet2: 'Magnetic resonance imaging;',
            bullet3: 'Computed radiography;',
            bullet4: 'X-ray;',
            bullet5: 'Ultrasound.'
          },
          updates: {
            title: 'Discover our Radiology updates',
            update1: 'Radiology - Skull and Descriptive Elements',
            update2: 'Radiology - Human Eye',
            update3: 'Radiology - Long Bones'
          }
        }
      }
    }
  }
}

export { messages }
